<template>
    <div class="orderbox">
        <!-- left -->
        <filterBox ref='filterBox' @handleSearch="handleSearch" @handlexport="handlexport" :buyerTypes="buyerTypes" :tabIndex="tabIndex"/>
        <!-- right -->
        <div class="main-cotent">
            <!-- tabs todo-ljm -->
            <vs-tabs v-model="tabIndex">
              <vs-tab :label="item.name" v-for="(item,index) in vsTabsList" :key="index" @click="orderTabChange(item,index)">
                <div class="top-search">
                    <!-- <div class="search-item order-manually pointer">
                        <div class="content">
                            <img class="search-icon" src="../../../src/assets/images/orderimg/sdxd.png" alt="" />
                            <span style="color:rgb(100, 100, 100)" class="search-label">手动下单</span>
                        </div>
                        <vs-dropdown>
                            <i class="material-icons">expand_more</i>
                            <vs-dropdown-menu>
                                <vs-dropdown-item style="width:100px" @click="createOrder">创建订单</vs-dropdown-item>
                                <vs-dropdown-item style="width:100px" @click="isShowPopImportOrder = true">批量导入</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div> -->
                    <div @click="handleSeparateBillAll" v-if="filtering('bill:invoice:batchSplit')" class="search-item  pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/cdgn.png" alt="" />
                        <span class="search-label">批量拆单</span>
                    </div>
                    <div @click="handleSeparateBillSku" v-if="filtering('bill:invoice:skuSplit')" class="search-item  pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/skucd.png" alt="" />
                        <span class="search-label">sku拆单</span>
                    </div>
                    <div @click="verifyConfirm" v-if="filtering('bill:invoice:batchConfirm')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/shqr.png" alt="" />
                        <span class="search-label">批量审核</span>
                    </div>
                    <div @click="handleSend" v-if="filtering('bill:invoice:batchPush')" class="search-item  pointer">
                        <img class="search-icon" style="width:25px;height:25px" src="../../../src/assets/images/orderimg/xkd.png" alt="" />
                        <span class="search-label">批量推单</span>
                    </div>
                    <div @click="handleExchange" v-if="filtering('bill:invoice:batchReplace')" class="search-item  pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/hsp.png" alt="" />
                        <span class="search-label">批量换商品</span>
                    </div>
                    <div @click="cancelOrder" v-if="filtering('bill:invoice:cancel')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/qxdd.png" alt="" />
                        <span class="search-label">取消订单</span>
                    </div>
                    <!-- <div @click="expectation" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/shqr.png" alt="" />
                        <span class="search-label">推单</span>
                    </div> -->

                    <!-- <div @click="expectation" class="search-item  pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/shqr.png" alt="" />
                        <span class="search-label expectation">拆单</span>
                    </div> -->
                    <div @click="toAbnormal" v-if="filtering('bill:invoice:abnormal')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/zyc.png" alt="" />
                        <span class="search-label">订单转异常</span>
                    </div>
                    <div @click="toNormal" v-if="filtering('bill:invoice:normal')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/zzc.png" alt="" />
                        <span class="search-label">订单转正常</span>
                    </div>
                    <div class="search-item pointer " v-if="filtering('bill:invoice:export')" @click.stop="download()">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/dc.png" alt="">
                        <span class="search-label">导出订单</span>
                    </div>
                    <!-- <div class="search-item pointer " @click.stop="distWare()">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/fpck.png" alt="">
                        <span class="search-label">分配仓库</span>
                    </div>  -->


                    <!-- <div @click="toNormal" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/zzc.png" alt="" />
                        <span class="search-label">转正常</span>
                    </div>
                    <div @click="handleSend" class="search-item mar-right pointer">
                        <img class="search-icon" style="width:25px;height:25px" src="../../../src/assets/images/orderimg/xkd.png" alt="" />
                        <span class="search-label">批量推单</span>
                    </div>
                    <div class="search-item pointer" @click.stop="download(tr)">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/dc.png" alt="">
                        <span class="search-label">导出</span>
                    </div>  -->
                </div>
                <div class="contentlist">
                    <el-table :height="orderHeight" border ref="orderListTable" :data="orderdatalist" style="width: 100%" highlight-current-row @selection-change="selectCurrentChange" @row-click="newCurrentChange">
                        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                        <el-table-column prop="orderNo" label="发货单号" width="160" align="center" fixed="left">
                            <template slot-scope="scope">
                                <div class="excrete-logo" v-if="scope.row.parentOrderNo">分</div>
                                <div class="excrete-logo" v-if="scope.row.combineType=='combine_ed'">合</div>
                                {{ scope.row.orderNo }}<br>{{scope.row.bodyName}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderBillNo" label="订货单号" width="150" align="center" ></el-table-column>
                        <el-table-column prop="outOrderBillNo" label="出库单号" width="150" align="center" ></el-table-column>
                        <!-- <el-table-column prop="express" label="物流单号" width="150" align="center" >
                            <template slot-scope="scope">
                                <div v-if="scope.row.billSendBo && (scope.row.billSendBo.expressNo != '' || scope.row.billSendBo.expressProvider != '')">
                                    <div>{{scope.row.billSendBo.expressProvider}}</div>
                                    <el-button v-if="scope.row.billSendBo" type="text" @click='getDetail(scope.row)'>{{ scope.row.billSendBo.expressNo }}</el-button>
                                </div>
                                <div v-else>
                                    {{scope.row.express}}
                                </div>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="express" label="物流商/物流单号" width="150" align="center" >
                            <template slot-scope="scope">
                                <div>{{scope.row.express}}</div>
                                <div>{{scope.row.transportNo}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderTime" label="创建日期" width="150" align="center" ></el-table-column>
                        <el-table-column prop="skuSummary" label="商品信息" width="100" align="center" >
                            <template slot-scope="scope">
                                <el-popover
                                    placement="bottom"
                                    width="800"
                                     @show="ncrFormat(scope.row)"
                                    @hide="Purchaseorderlist=[]"
                                    trigger="hover">
                                    <el-table v-loading="loadingasd" style="max-height:480px;overflow: auto;" border :data="Purchaseorderlist" :row-class-name="tableRowClassNameTab">
                                        <el-table-column width="100" align="center" property="goodsCategoryName" label="商品类别"></el-table-column>
                                        <el-table-column width="100" align="center" property="skuCode" label="商品编码"></el-table-column>
                                        <el-table-column width="150" align="center" property="skuName" label="商品名称"></el-table-column>
                                        <el-table-column width="150" align="center" property="barCode" label="69码"></el-table-column>
                                        <el-table-column width="80" align="center" property="num" label="下单数量"></el-table-column>
                                        <el-table-column width="80" align="center" property="availableAmount" label="可用库存"></el-table-column>
                                        <el-table-column width="80" align="center" property="sendSpecNum" label="发货数量">
                                            <template slot-scope="scopeChild">
                                                <span>{{scopeChild.row.sendSpecNum}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column width="100" align="center" property="untilPrice" label="原价"></el-table-column>
                                        <el-table-column width="100" align="center" property="hunitPrice" label="成交价"></el-table-column>
                                        <el-table-column width="100" align="center" property="itemPrice" label="原价金额"></el-table-column>
                                        <el-table-column width="100" align="center" property="hitemPrice" label="成交金额"></el-table-column>
                                    </el-table>
                                    <span slot="reference" style="cursor:pointer">{{scope.row.skuSummary}}</span>
                                </el-popover>
                            </template>
                        </el-table-column>

                         <el-table-column prop="orderNo" label="买家/类型" width="180" align="center" >
                            <template slot-scope="scope">
                                <div class="buyerName"> {{ scope.row.buyerName }} </div>
                                <div class="buyerType"> {{ scope.row.buyerType }} </div>
                                <div class="buyerType"> {{scope.row.buyerCode || ''}} </div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="" label="订单状态" width="100" align="center" >
                            <template slot-scope="scope">
                                <span class="order-status" :style="orderStatusColorStyle(scope.row.orderStatus)"></span>
                                {{ scope.row.orderStatusDesc }}
                                <div v-if="scope.row.orderStatus == 'ABNORMAL'" style="color:#aaa">{{scope.row.warnMessage}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="receiveName" label="收件人" width="100" align="center" ></el-table-column>
                        <el-table-column prop="receivePhone" label="联系方式" width="100" align="center" ></el-table-column>
                        <el-table-column prop="" label="收货地址" width="180" align="center" >
                            <template slot-scope="scope">
                                {{ scope.row.province + scope.row.area + scope.row.address}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sendWs" label="发货仓" width="130" align="center" ></el-table-column>
                        <el-table-column prop="sendLoc" label="仓位" width="130" align="center" ></el-table-column>
                        <el-table-column prop="isPod" label="签回单" align="center">
                            <template slot-scope="scope">{{scope.row.isPod === true?'是':(scope.row.isPod === false ?'否':'--')}}</template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="220" align="center" >
                            <template slot-scope="scope">
                                <el-button v-if="filtering('bill:invoice:update')&&scope.row.sellerIsMe && (scope.row.orderStatus === 'TO_REVIEW' || scope.row.orderStatus === 'ABNORMAL')" type="text" size="small" @click.stop="handleCheck(scope.row, scope.$index, true)">编辑</el-button>
                                <el-button type="text" size="small" @click.stop="handleCheck(scope.row, scope.$index, false)">查看</el-button>
                                <template v-if="scope.row.sellerIsMe">
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:cancel')&&scope.row.orderStatus === 'TO_PAY' || scope.row.orderStatus === 'TO_REVIEW' || scope.row.orderStatus === 'TO_SEND'" @click.stop="cancelOrder(scope.row, scope.$index)">取消订单</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:confirm')&&scope.row.orderStatus === 'TO_REVIEW'" @click.stop="priceCompare(scope.row, scope.$index)">审核确认</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:confirm')&&scope.row.orderStatus === 'TO_SEND'" @click.stop="cancelVerifyConfirm(scope.row, scope.$index)">取消审核</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:cancelPush')&&scope.row.orderStatus === 'PUSHED'" @click.stop="cancelDriveOrder(scope.row, scope.$index)">取消推单</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:normal')&&scope.row.orderStatus === 'ABNORMAL'" @click.stop="toNormal(scope.row, scope.$index)">转正常</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:abnormal')&&scope.row.orderStatus === 'TO_REVIEW' || scope.row.orderStatus === 'TO_SEND'" @click.stop="toAbnormal(scope.row, scope.$index)" >转异常</el-button>
                                    <!-- v-if="tr.orderStatus==='TO_SEND'" -->
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:push')&&scope.row.orderStatus == 'TO_SEND'" @click.stop="handleSend(scope.row, scope.$index)">推单</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:locking')&&scope.row.orderStatus === 'TO_SEND'" @click.stop="lockOrderConfirm(scope.row, scope.$index, true)">锁定</el-button>
                                    <el-button type="text" size="small" v-if="filtering('bill:invoice:locking')&&scope.row.orderStatus === 'LOCK_ED'" @click.stop="lockOrderConfirm(scope.row, scope.$index, false)">取消锁定</el-button>
                                </template>
                                <el-button type="text" size="small" v-if="filtering('bill:invoice:confirmDelivery')&& scope.row.showBtn" @click.stop="deliveryConfirm(scope.row, scope.$index)">确认出库</el-button>
                                <el-button type="text" size="small" v-if="filtering('bill:invoice:split')&&scope.row.seller == 1 && (scope.row.orderStatus == 'TO_REVIEW' || scope.row.orderStatus == 'ABNORMAL') && (scope.row.toPayPrice == scope.row.realityTotalPrice)" @click.stop="handleSeparateBillAll(scope.row, scope.$index)">拆单</el-button>
                                <el-button type="text" size="small" v-if="filtering('bill:invoice:merge')&&scope.row.sellerIsMe && scope.row.orderStatus == 'TO_REVIEW' && (scope.row.toPayPrice == scope.row.realityTotalPrice)" @click.stop="handleCombineBill(scope.row, scope.$index)">合单</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <gc-vs-pagination :pager="page" v-if="pageshow" totalName="totalCount" pageNoName='pagerNo' pageSizeName="pageSize" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" ></gc-vs-pagination>
                </div>
              </vs-tab>
            </vs-tabs>
            <addModal :popupActive="addPopupActive" :detail="detailDataList" />

            <!-- 创建订单窗口 -->
            <vs-popup id="import-dialog" @accept="importFund()" classContent="popup-example" title="批量导入" acceptText="确认导入" cancelText="取消" :active.sync="isShowPopImportOrder">
                <div class="import-wrap con-exemple-prompt">
                    <div class="import-label">导入文件</div>
                    <div class="right-part">
                        <el-upload
                            ref="upload"
                            class="upload-demo"
                            action="/data-dist/api/dist/ordering/import/order/manual"
                            :accept="accept"
                            :show-file-list = "false"
                            :limit="1000"
                            :on-success="uploadSuccess"
                            :headers="tokenHeader"
                        >
                            <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                        </el-upload>
                        <div class="downLoadText pointer" @click="downloadTemplate()">下载文件模板</div>
                    </div>
                </div>
                <!-- <vs-row style="margin-top:50px">
                    <vs-col vs-w="3" vs-offset="0.5"><vs-button color="primary" size="default" type="filled">确认导入</vs-button></vs-col>
                    <vs-col vs-w="3"><vs-button @click="isShowPopImportOrder = false" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row> -->
            </vs-popup>

            <!-- 推单/发货弹窗 -->
            <vs-prompt
              @cancel="cancelDeliverOrder"
              @accept="deliverOrder"
              title="推单"
              acceptText="确认推单"
              cancelText="取消"
              :is-valid="validDeliver"
              :active.sync="showDeliverPop">
                <div style="width: 100%">
                    <!-- v-if="sendData.length > 1" -->
                    <div class="top" >批量选择
                        <vs-button :disabled="!batchSelected.length" color="primary" type="border" @click="batchSelectTemplate">运费模板</vs-button>
                        <vs-button style="margin-left: 10px;" :disabled="!batchSelected.length" color="primary" type="border" @click="batchSelectPod">签回单</vs-button>
                    </div>
                    <vs-table multiple v-model="batchSelected" :data="sendData" class="wid100" noDataText="暂无数据">
                        <template slot="thead">
                            <vs-th>订单编号</vs-th>
                            <vs-th>仓库</vs-th>
                            <vs-th>仓位</vs-th>
                            <vs-th>运费模板</vs-th>
                            <vs-th>签回单</vs-th>
                        </template>

                        <template slot-scope="{ data }" v-if="sendDataShow">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                <vs-td :data="tr.orderNo">
                                    {{tr.orderNo}}
                                </vs-td>
                                <vs-td :data="tr.wsName">
                                    {{tr.wsName}}
                                </vs-td>
                                <vs-td :data="tr.locName">
                                    {{tr.locName}}
                                </vs-td>
                                <vs-td :data="tr.frtId">
                                    <el-select v-model="data[indextr].frtId" @change="sendFrtIdChange()" placeholder="请选择">
                                        <el-option
                                            v-for="item in tmsFrtOptions"
                                            :key="item.id"
                                            :label="item.label"
                                            :value="item.id">
                                            </el-option>
                                    </el-select>
                                </vs-td>
                                <vs-td :data="tr.isPod">
                                    <el-select :disabled="data[indextr].wsName.indexOf('顺丰仓') === -1 ? true:false" v-model="data[indextr].isPod" @change="sendFrtIdChange()" placeholder="请选择">
                                        <el-option label="是" :value="true"></el-option>
                                        <el-option label="否" :value="false"></el-option>
                                    </el-select>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <div>*部分库存不足的订单，自动转异常</div>

                    <vs-popup
                            style="z-index: 2500"
                        :active.sync="batchSelectTemplateVisible"
                        title="批量选择运费模板">
                        <el-select v-model="batchFrtId" placeholder="请选择">
                            <el-option
                                v-for="item in tmsFrtOptions"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                                </el-option>
                        </el-select>
                        <div style="margin-top:20px;">
                            <vs-button color="primary" type="filled" @click="handleBatchSelect">保存</vs-button>
                            <vs-button color="primary" type="border" style="margin-left:9px;" @click="cancelhandleBatch()">取消</vs-button>
                        </div>
                    </vs-popup>
                    <!--签回单弹窗-->
                    <vs-popup
                            style="z-index: 2500"
                            :active.sync="podModal"
                            title="批量选择签回单">
                        <el-select v-model="isPod" placeholder="请选择">
                            <el-option :value="true" label="是"></el-option>
                            <el-option :value="false" label="否"></el-option>
                        </el-select>
                        <div style="margin-top:20px;">
                            <vs-button color="primary" type="filled" @click="handleBatchPod">保存</vs-button>
                            <vs-button color="primary" type="border" style="margin-left:9px;" @click="cancelIspod()">取消</vs-button>
                        </div>
                    </vs-popup>
                </div>
            </vs-prompt>
            <!-- 批量换商品 -->
            <vs-popup classContent="popup-example abnormal" title="批量换商品" @close="cancelExchange()" :active.sync="showExchange">
                <form class="frombox" id="data-list-list-view">
                    <vs-row>
                        替换全部选中的订单
                    </vs-row>
                    <vs-row style="margin-top:20px; position: relative; z-index: 1000;">
                        <vs-col vs-w="3" class="colTitle"><span class="redText">*</span>被替换的商品</vs-col>
                        <vs-col vs-w="5">
                            <div>
                                <search-input
                                ref="commoditySuggest"
                                :autoFocus="false"
                                :data="goodsOptions"
                                placeholder="请输入原商品"
                                inputClassses="buyer-full"
                                show-action
                                show-pinned
                                hideGroupTitle
                                background-overlay
                                remainInputValue
                                showName="skuName"
                                @input="searchInputSuggest"
                                @selected="selectOneGood" />
                            </div>
                        </vs-col>
                    </vs-row>
                    <vs-row style="margin-top:20px">
                        <vs-col vs-w="3" class="colTitle"><span class="redText">*</span>替换成新商品</vs-col>
                        <vs-col vs-w="5">
                            <div>
                            <search-input
                            ref="commodityExchangeSuggest"
                            :autoFocus="false"
                            :data="goodsOptions2"
                            placeholder="请输入替换商品"
                            inputClassses="buyer-full"
                            show-action
                            show-pinned
                            hideGroupTitle
                            background-overlay
                            remainInputValue
                            showName="skuName"
                            @input="exchangeInputSuggest"
                            @selected="selectExchangeGood" />
                        </div>
                        </vs-col>
                    </vs-row>
                </form>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2.5" vs-offset="9.5"><vs-button @click="commodityExchange" color="primary" size="default" type="filled">立即替换</vs-button></vs-col>
                    <!-- <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OrderAbnormalbtn" color="primary" size="default" type="border">取消</vs-button></vs-col> -->
                </vs-row>
            </vs-popup>
            <!-- 编辑卖家备注 -->
            <vs-popup classContent="popup-example deliver-pop" title="卖家备注" :active.sync="sellerRemarkPop">
                <form class="frombox" id="data-list-list-view"><vs-textarea v-model="sellerRemark" maxlength="200" class="edit-remark-textarea" /></form>
                <div class="deliver-btn flex flexCenter">
                    <vs-button color="primary" type="filled" @click="saveSellerRemark">保存</vs-button>
                    <vs-button color="primary" type="border" style="margin-left:9px;" @click="sellerRemarkPop = false">取消</vs-button>
                </div>
            </vs-popup>
            <!-- 选仓库弹窗 -->
            <vs-popup classContent="popup-example" title="选择仓库模板" :active.sync="popupActive2Xck">
                <form class="frombox" id="data-list-list-view">
                    <vs-row>
                        <vs-col vs-w="5"><vs-input class="w-full" placeholder="搜索仓库模板" /></vs-col>
                        <vs-col vs-w="2" vs-offset="0.2"><vs-button color="primary" size="default" type="filled">搜索</vs-button></vs-col>
                    </vs-row>
                </form>
                <div>
                    <ul class="centerx" style="margin-left:30px">
                        <li><vs-radio v-model="radios1" vs-value="luis">Luis</vs-radio></li>
                        <li><vs-radio v-model="radios1" vs-value="carols">Carols</vs-radio></li>
                        <li><vs-radio v-model="radios1" vs-value="summer">Summer</vs-radio></li>
                        <li><vs-radio v-model="radios1" vs-value="lyon">Lyon - disabled</vs-radio></li>
                    </ul>
                </div>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>

            <!-- 审核确认弹窗组件 -->
            <send-review ref="sendReview" :orders="reviewOrders" ></send-review>

            <!-- 审核确认弹窗 -->
            <vs-prompt class="verify confim-popup" classContent="popup-example" title="审核确认" acceptText="确认审核" cancelText="取消" :active.sync="popupActive2Shqr" :is-valid="validateVerify" @cancel="popupActive2Shqr=false" @accept="OnconfirmOrder">
                <div class="flex alignCenter deliver-dialog" v-if="isSearchShow">
                    <div class="flex alignCenter">
                        <div>选择主体</div>
                        <template>
                            <v-select :disabled="isBodyId" v-model="deliverParam.bodyId" :options="mainOptions" :reduce="opt => opt.id" placeholder="请选择主体" @change="getMainOptions" @input="getMainOptions" class="marLeft16">
                                <div slot="no-options">暂无选项</div>
                            </v-select>
                        </template>
                    </div>
                    <div class="flex alignCenter marLeft16">
                        <div>选择仓库</div>
                        <template>
                            <v-select v-model="deliverParam.wsId" :options="distOptions" :reduce="opt => opt.id" placeholder="请选择仓库" @change="getLocOptions" @input="getLocOptions" class="marLeft16">
                                <div slot="no-options">暂无选项</div>
                            </v-select>
                        </template>
                    </div>
                    <div class="flex alignCenter marLeft16">
                        <div>选择仓位</div>
                        <template>
                            <v-select v-model="deliverParam.locId" :options="locOptions" :reduce="opt => opt.id" placeholder="请选择仓位" class="marLeft16">
                                <div slot="no-options">暂无选项</div>
                            </v-select>
                        </template>
                    </div>
                </div>
                <div class="table-sec-box">
                    <div v-for="(tab, index) in stockTabledata" :key="index">
                        <div>订单号：{{tab.orderNo}}</div>
                        <el-table :data="tab.orderReviewDetailBoList" class="marTop20 marBottom20" :span-method="columnSpanMethod" style="width: 100%;" :row-class-name="tableRowClassName">
                            <el-table-column label="69码" prop="barCode" width="130" align="center"></el-table-column>
                            <el-table-column label="商品名称" prop="skuName" width="230" align="center"></el-table-column>
                            <el-table-column label="下单数量" prop="orderAmount" width="150" align="center" ></el-table-column>
                            <el-table-column label="发货商品" prop="newSendSkuName" width="270" align="center" >
                                <template slot-scope="scope">
                                    <span v-if="isSearchShow">{{scope.row.newSendSkuName}}</span>
                                    <span v-else>{{scope.row.sendSkuName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="发货数量" prop="newSendAmount" width="90" align="center" >
                                <template slot-scope="scope">
                                    <div class="flex flex-align" v-if="isSearchShow">
                                        <el-input :disabled="scope.row.actualAmount ? false : true" style="flex:1;margin-right:5px;padding:0;" v-model="scope.row.newSendAmount" placeholder="" @input="changInputSec(scope.row, tab.orderNo)"></el-input>{{scope.row.sendBoxUnit}}
                                    </div>
                                    <div class="flex flex-align" v-else>
                                        <el-input :disabled="scope.row.actualAmount ? false : true" style="flex:1;margin-right:5px;padding:0;" v-model="scope.row.sendAmount" placeholder="" @input="changInputSec(scope.row, tab.orderNo)"></el-input>{{scope.row.sendSkuUnit}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="当前库存" prop="actualAmount" width="100" align="center" >
                                <template slot-scope="scope">
                                    <div class="flex flex-align el-num-height">
                                        {{scope.row.actualAmount}}
                                        <span v-if="isSearchShow">{{scope.row.sendBoxUnit}}</span>
                                        <span v-else>{{scope.row.sendSkuUnit}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="发货后库存" prop="actualAmountEnd" width="90" align="center" >
                                <template slot-scope="scope">
                                    <div class="flex flex-align el-num-height">
                                        {{scope.row.actualAmountEnd}}
                                        <span v-if="isSearchShow">{{scope.row.sendBoxUnit}}</span>
                                        <span v-else>{{scope.row.sendSkuUnit}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </vs-prompt>

            <!-- 取消推单弹窗 -->
            <vs-popup classContent="popup-example" title="取消推单" :active.sync="popupActive2Qxtd">
                <div class="modal-title" style="margin-left:22px">您正在取消推单，注意取消后订单会变为‘待发货’，如需发货需重新推单！</div>
                <!-- <div class="modal-title" style="margin-left:22px;color:rgb(255, 67, 61);">取消推单会扣除部分费用，是否仍要取消推单？</div> -->
                <form class="frombox" style="margin-top:30px" id="data-list-list-view">
                    <vs-row>
                        <vs-col vs-w="3" class="colTitle">取消推单原因说明</vs-col>
                        <vs-col vs-w="9"><vs-input v-model="cancelDriveModel" class="w-full" placeholder="输入取消推单原因" /></vs-col>
                    </vs-row>
                </form>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelDriveOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OncancelDrivebtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>

            <!-- 取消订单弹窗 -->
            <vs-popup classContent="popup-example" title="取消订单" :active.sync="popupActive2Qxdd">
                <div class="modal-title" style="margin-left:22px">您正在取消订单，注意取消订单后将会同步到客户。系统会返回已扣除的资金和可购买量，请仔细操作！</div>
                <form class="frombox" style="margin-top:50px" id="data-list-list-view">
                    <vs-row>
                        <vs-col vs-w="3" class="colTitle">取消原因说明</vs-col>
                        <vs-col vs-w="9"><vs-input v-model="cancelModel" class="w-full" placeholder="输入取消原因" /></vs-col>
                    </vs-row>
                </form>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="Oncancelbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>
            <!-- 取消审核弹窗 -->
            <vs-popup classContent="popup-example" title="取消审核" :active.sync="popupActive2Qxsh">
                <div class="modal-title" style="margin-left:22px">您正在取消审核，注意取消审核后订单会变成“待审核”，订单需重新审核～</div>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelAuditOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OncancelAuditbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>

            <!-- 标注异常弹窗 -->
            <vs-popup classContent="popup-example abnormal" title="标注异常" :active.sync="popupActive2Bzyc">
                <form class="frombox" id="data-list-list-view">
                    <vs-row>
                        <vs-col vs-w="2" class="colTitle">异常原因</vs-col>
                        <vs-col vs-w="5"><v-select :options="TreeAbnormal" v-model="AbnormalModel" label="val" :reduce="opt => opt.key" :dir="$vs.rtl ? 'rtl' : 'ltr'" /></vs-col>
                    </vs-row>
                </form>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OnOrderAbnormal" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="OrderAbnormalbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>
            <!-- 转正常弹窗 -->
            <vs-popup classContent="popup-example" title="转正常" :active.sync="popupActive2Zzc">
                <div class="modal-title">确定将此订单转为正常吗？</div>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OnNormalOk" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="normalbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>

            <!-- 物流信息弹框 -->
            <vs-prompt
                @cancel="rowInfo = {}"
                :title="detailData.expressName + '：' + detailData.transitNo"
                acceptText="确认"
                cancelText="取消"
                class="follow-detail"
                :active.sync="showDetailDialog"
            >
                <div class="timeline-wrapper">
                    <div class="addressee">
                        <div class="addressee-line"></div>
                        <div class="addressee-item-point"><span>收</span></div>
                        <div class="addressee-item-content">{{ detailData.receiveAddress || '[收货地址]' }}</div>
                    </div>
                    <template :v-if="detailData.traces.length > 0" v-for="(item, index) in detailData.traces">
                        <vx-timeline
                            :showLine="index !== detailData.traces.length - 1"
                            :key="index"
                            :timer="{
                                date: getTime('day', item.time),
                                time: getTime('time', item.time)
                            }"
                            :title="item.state"
                            :message="item.trace"
                        />
                    </template>
                </div>
            </vs-prompt>
            <el-dialog :visible.sync="warePopupDialog" width="400px" center>
                <template slot="title">
                    <span>分配发货仓-已选中未分配发货仓的发货单（{{Orderselected.length}})</span>
                </template>
                <div class="group-body">
                    <div class="flex flex-align marBottom10">
                        <span class="marRight10">仓库</span>
                        <el-select style="flex:1" v-model="wareSecId" placeholder="请选择仓库" @change="selectWare">
                            <el-option
                                v-for="(item, index) in wareList"
                                :key="index"
                                :label="item.wsName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="flex flex-align">
                        <span class="marRight10">仓位</span>
                        <el-select style="flex:1" v-model="locSecId" placeholder="请选择仓位">
                            <el-option
                                v-for="(item, index) in locOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="warePopupDialog = false">取 消</el-button>
                    <el-button type="primary" @click="warePopupConfirm">确 定</el-button>
                </span>
            </el-dialog>
            <!--批量换商品成功弹窗 wn-->
            <el-dialog
                    class="changeModal"
                    :visible.sync="changeGoodsModal"
                    width="30%"
                    title="成功"
                    @close="closeChangeModal">
                <div class="box-card">
                    <div style="padding: 18px 0;border-bottom: 1px solid #eaeefb" v-for="(item,index) in changeGoodsData" :key="index">{{index+1+'.'+item}}</div>

                </div>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeChangeModal">确 定</el-button>
              </span>
            </el-dialog>

        </div>
        <BreakUpOrderSku
            :visible.sync="breakUpOrderSkuShow"
            :Orderselected="Orderselected"
            @success="handleBreakUpOrderSuccess"
        />
        <!-- 批量拆单 -->
        <BreakUpOrderAll @success="handleBreakUpOrderSuccess"
                      :visible.sync="breakUpOrderShow"
                      :tableData="breakUpOrderList"
                      :orderNo="currentOrderNo"
                      :allStockList="allStockList" />
        <!-- 合单 -->
        <CombineOrder ref="combineOrder" @success="handleCombineOrderSuccess"
                      :visible.sync="combineOrderShow"
                      :orderInfo="currCombineOrderInfo"
                      :orderNo="currCombineOrderInfo.orderNo"
                      @uptOrderNo="currCombineOrderInfo = {}" />
        <!-- 发货单 -->
        <invoice-detail ref="invoiceDetail" @eventname="getOrderformList"  @getstatussx="getOrderformList"></invoice-detail>
    </div>
</template>

<script>
import invoiceDetail from '@/modules/order/orderDetail/invoiceDetail';
import store from './store.js';
import filterBox from './filterBox.vue';
import addModal from './addModal.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import { OrderApi } from '@/modules/server-api/commodity-sys/order';
import { LogisticsApi } from '@/modules/server-api/commodity-sys/logistics';
import { CommodityGoodsyApi } from "@/modules/server-api/commodity-sys/goods-manage";
import { $busErrorCode, uploadHeader } from '@/modules/commodity-sys/common.js';
import {
    WmsWarehouseApi,
    Mod_Warehouse_Types_Options //库存类型
} from '@/modules/server-api/wms-manage/warehouse';
import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";
import { WmsStockApi } from "@/modules/server-api/wms-manage/stock";
import commondityTable from '@/modules/commodity-sys/components/commodity-table';

import VsTable from "./vsTable/vsTable"
import VsTd from "./vsTable/vsTd"
import VsTh from "./vsTable/vsTh"
import VsTr from "./vsTable/vsTr"

import BreakUpOrder from "./components/BreakUpOrder" //单个订单拆单
import BreakUpOrderAll from "./components/BreakUpOrderAll" //多个订单拆单
import BreakUpOrderSku from "./components/BreakUpOrderSku" //sku拆单
import VerifyConfirm from './components/verifyCofirm'

import sendReview from './components/SendReview'
import CombineOrder from './components/CombineOrder'
import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
export default {
    components: {
        flatPickr,
        'v-select': vSelect,
        filterBox,
        addModal,
        commondityTable,
        invoiceDetail,

        VsTable,
        VsTd,
        VsTh,
        VsTr,
        BreakUpOrder,
        BreakUpOrderAll,
        BreakUpOrderSku,
        VerifyConfirm,
        CombineOrder,
        SearchInput,
        sendReview
    },
    computed:{
      // validDeliver(){
      //   return this.sendData.every(item => item.frtId)
      // },
      validateVerify() {
        if(this.isSearchShow){
            return (this.deliverParam.wsId !== '' && this.deliverParam.locId !== ''  && this.deliverParam.locId !== null && this.deliverFlag)
        }else{
            return (this.deliverFlag)
        }
      }
    },
    mixins: [store],
    beforeRouteEnter (to, from, next) {
        if(from.path != '/modules/order/orderDetail'){
            sessionStorage.removeItem("searchData")
            sessionStorage.removeItem("tabIndex")
            sessionStorage.removeItem("vsTabsList")
        }
        next()
    },
    data() {
        return {
            isPod:false,
            showBtn:false,
            changeGoodsModal:false,//批量换商品成功弹窗
            changeGoodsData:[],//成功返回数据
            orderHeight: 0, //订单高度
            tabIndex:0,
            tabInfo:{
                id:0,
                supplierType:"全部",
                name:"全部",
                dealerType:""
                },
                tuidanid:'',//推单id
            sendDataShow:true,
            loadingasd:false,
            orderSearchInfo:{}, //详情页过来的查询条件
            currentOrderNo: '', //当前要拆单的订单号
            breakUpOrderList: [], //当前拆单商品列表
            breakUpOrderShow: false, //拆单弹框
            breakUpOrderSkuShow: false, //sku拆单弹窗
            combineOrderShow: false, //合单
            currCombineOrderInfo: {}, //当前要合单的订单
            searchData: {
                orderNo: '', // 查询的订单编号
                invoiceNo: '', //发货单号
                billNo: '', //出库单号
                payNo: '', //支付单号
                transitNo: '', //快递单号
                startTime: '', //下单开始日期
                endTime: '', //下单结束日期
                startPushTime: '', //推单开始日期
                endPushTime: '', //推单结束日期
                startOrcTime: '', //出库开始日期
                endOrcTime: '', //出库结束日期
                startSendTime: '', //发货开始日期
                endSendTime: '', //发货结束日期
                startPayTime: '', //付款开始日期
                endPayTime: '', //付款结束日期
                billSource: '', //订单来源
                orderStatusList: [], //订单状态
                orderStatusAbnormalList: [], //异常状态
                sourceChannelList: [], //订单渠道
                categoryId: [], //商品分类
                buyerSortCode: '', //门店编码
                skuCode: '', //物流编码
                skuName: '', //商品名称
                barCode: '', //商品69码
                snCode: '', //sn码
                paySource: '', //支付方式
                buyer:'', //买家名称id
                buyerName:'',//买家名称
                buyerCode: '', //买家编码
                buyerType: '', //买家类型
                buyerPhone: '', //买家手机号
                seller: '', //卖家id
                sellerCode: '', //卖家编码
                sellerPhone: '', //卖家手机号
                receiveName: '', //收货人姓名
                receivePhone: '', //收货人手机号
                province: '', //收货人省
                city: '', //收货人市
                area: '', //收货人区
                bodyId: '', //主体id
                wsId: '', //仓库id
                locId: '', //仓位id
                currency: '', //币种
                supplierType:'', //卖家类型
                dealerType:'',  //买家
                dealerTypeList:[]

            },
            validDeliver: false,
            orderdatalist: [], //订单列表
            Orderselected: [], //选中的订单
            OrderDriveselected:[],//推单选中
            OrderReviewselected:[],//选中的审核
            pageshow:true,
            page: {
                // 分页
                pageNo: 1,
                pageSize: 20,
                totalCount: 0
            },
            clickOrderNo: '',
            // tabs todo-ljm
            vsTabsList:[
                {
                id:0,
                supplierType:"全部",
                name:"全部",
                dealerType:""
                }
            ],
            //下单或编辑弹窗
            addPopupActive: false,
            detailDataList: {}, //详情信息

            popupActive: false, //手动下单弹窗
            isShowPopImportOrder: false, //批量导入下单弹窗
            popupActiveXzsp: false, //新增商品弹窗
            popupActiveDetail: false, //查看详情弹窗
            showDeliverPop: false, //发货
            showExchange: false, //批量换商品
            popupActive2Xck: false, //选仓库
            popupActive2Shqr: false, //审核确认
            popupActive2Qxtd: false, //取消推单
            popupActive2Qxdd: false, //取消订单
            popupActive2Qxsh: false, //取消审核
            popupActive2Bzyc: false, //标注异常
            popupActive2Sjzf: false, //手机支付
            popupActive2Zzc: false, //转正常
            radios1: 'hhh', //选择快递
            OrdermanuallyFormData: {
                //手动下单字段
                fromDepart: '',
                sellerRemark: '',
                buyerRemark: '',
                sourceChannel: '',
                buyer: '',
                buyerName: '',
                buyerType: '',
                address: '',
                buyerPhone: ''
            },
            OrdermanuallyArr: {
                //手动下单下拉框数据
                ChannelListArr: [] //渠道列表
            },
            OrderDetailArr: {
                //订单详情下拉框数据
                PaysListArr: [] //支付方式列表
            },
            cancelModel: '', //取消订单原因
            cancelDriveModel: '', //取消推单原因
            AbnormalModel: '', //标注异常原因
            addpaytitle: {
                //添加手机支付的字段
                paySource: '',
                payTime: '',
                payBillNo: '',
                totalPrice: ''
            },
            TreeState: [], //订单状态数组
            TreeChannel: [], //订单状态数组
            TreeAbnormal: [], //订单状态数组
            GoaddStoreListData: [], //整个商品订单列表
            checkBox1State: [], //订单状态选择数组
            checkBox1Channel: [], //订单渠道选择数组

            judgeQxdd: '', //判断是多选删除还是反选删除
            judgeZyc: '', //判断是多选异常还是反选异常
            judgeShqr: '', //判断是多选审核确认还是反选审核确认
            addStoreselected: [], //新增商品选中的
            types: 0, //添加了几种
            addnumber: 0, //添加了几种
            totalCount: Number,

            tmsFrtOptions: [], //运费模板选项
            mainOptions: [], //主体选项
            distOptions: [], //分仓选项
            locOptions: [], //仓位选项
            deliverParam: {
                wsId: '',
                locId: ''
            },
            verifyConfirmId: [],
            batchFrtId: '',
            batchSelectTemplateVisible: false,
            podModal:false,
            sendData: [],
            batchSelected: [],
            stockData: [],
            stockTabledata: [], //隐藏没有发货的商品，临时存储
            skuCodes: [],
            deliverFlag: true, //是否可以发货
            sellerRemarkPop: false, //编辑卖家备注
            sellerRemark: '',
            tokenHeader: uploadHeader,
            accept: '.excel, .xlsx',

            // 物流弹框
            detailData: {},
            showDetailDialog: false,
            rowInfo: {},

            //拆单的时候需要仓库动态表头
            allStockList: [],
            searchFlag:true,
            goodsOptions:[],
            goodsOptions2:[],
            goodsExchangeOptions:[],
            oneGoodSelected:{},  //批量替换商品原商品
            selectExchange:{}, //批量替换商品替换商品
            exchangeOrderNo:[],
            currencyTypeList:[
              {id: 'RMB', label: 'RMB', symbol:'￥'},
              {id: 'USD', label: 'USD', symbol:'$'}
            ],
            levelOne: ['一次性客户','内部客户','海外客户','省代PD','大零售商SCA','大连锁商SKA','CVS'],
            levelTwo: ['地代RD','省代下级零售商CA','省代下级无店商CAN'],
            levelThree: ['地代下级零售商CAD','地代下级无店商CAND'],
            levelStore:[ '专卖店', '明星店', '集合店', '直营店' ],
            buyerTypes: [],
            wareList: [],  //分配仓库列表
            warePopupDialog: false, //分配仓库弹窗
            wareSecId: '', //选中分配仓库
            wareOrderNos: '', //选中的订单id
            locSecId: '', //选中分配的仓位
            isSearchShow: false, //仓库搜索是否展示
            isBodyId: false, //主体是否可以选择
            Purchaseorderlist:[],//商品信息列表
            examParam:{
                wsId: '',
                locId: ''
            },
            reviewOrders:[]
        };
    },
    created() {
        window.addEventListener('resize', this.getHeight) // 注册监听器
        this.getHeight();
        let tabsList = sessionStorage.getItem('vsTabsList')
        if (tabsList) {
            this.vsTabsList = JSON.parse(tabsList)
        } else {
          this.gitTabsList();
        }
        this.searchData.tabIndex = 0;
    },
    mounted(){
        let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
        this.orderSearchInfo = JSON.parse(searchInfo)  //从详情带过来的查询条件
        // this.getOrderformList();
        this.getPaysList();
        this.getAbnormalList();
        let data = {};
        this.getBuyertype(data);
    },
    methods: {
        //默认获取近一个月时间
        getBaseTime(){
            let end = new Date();
            let start = new Date();

            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            console.log(start,end);
            start = this.dateFormat("YYYY-mm-dd", start);
            end = this.dateFormat("YYYY-mm-dd", end);
            this.searchData.startTime = start;
            this.searchData.endTime = end;
            // this.searchData.startTime = start;
            // this.searchData.endTime = end;
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },
        //鼠标移入表格事件
        async ncrFormat(row){
            this.loadingasd=true
            let data ={
                seller:row.seller,
                bodyId:row.bodyId,
                orderNos:[row.orderNo]
            }
            let res = await OrderApi.Commodityinformation(data);
            this.Purchaseorderlist=res.result
            this.loadingasd=false
            console.log(row)
        },
        tableRowClassNameTab({row, rowIndex}) {
            if (row.availableAmount < row.num) {
                return 'amount-red';
            }
            return '';
        },
        getHeight() {
            this.orderHeight = window.innerHeight - 230
        },
        selectCurrentChange(val) {
            this.Orderselected = val;
        },
        newCurrentChange(row) {
            this.$refs.orderListTable[0].toggleRowSelection(row)
        },
        //确认出库
         deliveryConfirm(item, index){
            let that = this;
            that.$prompt('物流单号', '确认出库', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,50}$/,
                inputErrorMessage: '请输入物流单号且长度不超过50字符'
            }).then(async ({ value }) => {
                let param = {
                    orderNo: item.orderNo,
                    logisticsNumber: value,
                }
                let resp = await OrderApi.confirmDeliOrder(param);
                if(resp.code == 0 && resp.succ == 1){
                    this.$notifySuccess("出库成功");
                    this.getOrderformList();
                }else{
                    return this.$notifyError(resp.error || '出库失败');
                }
            }).catch(() => {});
        },


        expectation(){
        //    alert('敬请期待～')
        const h = this.$createElement;
            this.$message({
            message: h('p', null, [
                h('span', null, '当前功能 '),
                h('i', { style: 'color: teal' }, '敬请期待～')
            ])
            });
        },
        // 获取tab名称列表 todo
        async gitTabsList(){
            // this.vsTabsList = []
            let all = {
                id:0,
                supplierType:"全部",
                dealerType:""
            }
            let tabsList = this.vsTabsList;
            // 调接口赋值 todo
            let res = await OrderApi.getTabsList({});
            tabsList = res.result
            // 调接口赋值end todo
            tabsList.unshift(all)
            tabsList.map(tab =>{
                if (tab.dealerType == '') {
                    tab.dealerType = '下级'
                }
                if (tab.supplierType == '全部') {
                    tab.name = tab.supplierType
                } else {
                    tab.name = tab.supplierType + '→' + tab.dealerType
                }

            })
            this.vsTabsList = tabsList
            sessionStorage.setItem('vsTabsList', JSON.stringify(this.vsTabsList));

        },
        createOrder(){
            //改为本地缓存，创建订单的时候清空 sessionStorage.removeItem("updateSkuItemList");
            this.$router.push({ path: '/modules/order/createOrder'})
        },
        //导出订单的参数
        handlexport(val){
            this.searchData=val
        },
        // ========= 右侧搜索
        async handleSearch(val) {
            //清空已选择的选项
            this.Orderselected = [];
            this.searchData = val;
            if (this.tabInfo.supplierType === '全部') {
                this.searchData.supplierType = ''
            } else {
                this.searchData.supplierType = this.tabInfo.supplierType
            }
            if (this.tabInfo.dealerType === '下级') {
                this.searchData.dealerType = ''
            } else if (this.tabInfo.dealerType === '门店') {
                this.searchData.dealerType = ''
            }else{
                this.searchData.dealerType =this.tabInfo.dealerType
            }
            console.log(val.buyerType)
            if ( val.isTab ){
                this.setTabBuyerType(val);
            }else if(val.buyerType=='门店客户'){
                let list = await OrderApi.getBuyertype({cus_type: 2});
                let arr =[]
                console.log(this.buyerTypeList)
                list.result.map((item) => {
                    arr.push(
                        item.customer_name,
                    );
                });
                val.dealerTypeList = arr;
                // val.buyerType = null;
                this.page.pageNo = 1;
                this.getOrderformList();
            }else{
                if ( val.buyerType === '' || val.buyerType === null ){
                    this.tabIndex = val.tabIndex;
                    this.setTabBuyerType(val);
                }else{
                    val.dealerTypeList = [val.buyerType];
                    this.page.pageNo = 1;
                    this.getOrderformList();
                }
            }
            this.pageshow = false;//让分页隐藏
            this.$nextTick(() => {//重新渲染分页
                this.pageshow = true;
            });
        },
        //卖家类型
        async getBuyertype(data) {
            let buyerTypeList = [];
            let res = await OrderApi.getBuyertype(data);
            res.result.map((item) => {
                buyerTypeList.push(
                item.customer_name,
                );
            });
            this.searchData.dealerTypeList = buyerTypeList
            this.buyerTypes = buyerTypeList;
            this.page.pageNo = 1;
            this.getOrderformList();
        },
        setTabBuyerType(val) {
            let buyerType = null;
            let data = {};
            if (this.tabIndex === 4) {
                data = {
                    cus_type: 2,
                };
            } else if (this.tabIndex === 1) {
                data = {
                    level: 1,
                };
            } else if (this.tabIndex === 2) {
                data = {
                    level: 2,
                    cus_type: 1,
                };
            } else if (this.tabIndex === 3) {
                data = {
                    level: 3,
                };
            } else if (this.tabIndex === 5) {
                data = {
                    level: 5,
                };
            } else {
                data = {};
            }
            this.getBuyertype(data);
            if (val.isTab) {
                this.$refs.filterBox.refreshBuyerType(this.buyerTypeList, this.tabIndex);
            }
        },
        // 切换tab
        orderTabChange(val,index){
            this.tabInfo = val;
            let info = this.searchData;
            info.dealerType = this.searchData.dealerType === '门店'? '' :this.searchData.dealerType;  //买家
            // info.buyerType = ''; //左侧筛选的买家类型
            if (index !== 0) {
                info.supplierType = val.supplierType; //卖家
                if ( val.dealerType === '门店'){
                  info.dealerType = '' //买家
                }else {
                  info.dealerType = val.dealerType === '下级' ? '' : val.dealerType //买家
                }
            } else {
                info.supplierType = '';
                info.dealerType =''
            }
            info.isTab = true;
            console.log(info)
            this.searchData.buyerType = '';
            this.handleSearch(info)
        },
        //导入文件
        uploadSuccess(response, file, fileList) {
            if (response.succ == 1 && response.code != $busErrorCode) {
                this.isShowPopImportOrder = false;
                this.$notifySuccess("导入成功")
                this.getOrderformList();
            } else {
                this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
            }
        },

        //获取物流信息
        async getDetail(row) {
            this.showDetailDialog = true;
            let { orderNo } = row;
            let resp = await OrderApi.getOrderFollowInfo({
                orderNo,
            });
            this.detailData = resp.result || {
                // expressName: row.billSendBo.expressProvider || '',
                transitNo: '',
                receiveAddress: '',
                traces: []
            };
            this.detailData.expressName = row.billSendBo.expressProvider|| this.detailData.expressName || ''
        },
        // 单个选择运费模板
        sendFrtIdChange(){
            this.sendDataShow = false;//让分页隐藏
            this.$nextTick(() => {//重新渲染分页
                this.sendDataShow = true;
            })

        },
        getTime(type, value) {
            let arr = value.split(' ');
            return type === 'day' ? arr[0] : arr[1];
        },
        //锁定订单
        lockOrderConfirm(tr,indextr, isLock){
          let lockTitle = '您确认' + (isLock ? '': '取消') + '锁定该订单吗？';
          let lockBtnText = isLock ? '锁定': '取消锁定';
          this.$vs.dialog({
            type: "confirm",
            title: `操作提示`,
            text: lockTitle,
            acceptText: lockBtnText,
            cancelText: "取消",
            accept: () => {
              this.lockOrder(tr,indextr, isLock);
            }
          });
        },
        //锁定订单
         async lockOrder(tr, index, isLock) {
            this.$vs.loading()
            let sendIds = []
            if (index === undefined) {
              if (this.Orderselected.length == 0) {
                return this.$notifyError('请选择订单');
              }
              //校验是否是总部可操作的状态
              if(!this.getExtraOrder()){
                return false;
              }
              //检测当前元素是否都不等于TO_SEND，如果有一个等于TO_SEND，返回false，如果都不等于，返回true
              const temp = this.Orderselected.every(item => item.orderStatus !== 'TO_SEND');
              if (temp) {
                return this.$notifyError('选择的订单中有不可锁定的订单，请重新选择');
              }
              sendIds = this.Orderselected.map(item => item.orderNo)
            } else {
              this.clickOrderNo = tr.orderNo
              sendIds = [tr.orderNo];
            }
            //锁定
            let resp;
            if(isLock){
              resp = await OrderApi.lockOrder({
                orderNos : sendIds
              });
            }else{
              resp = await OrderApi.cancelLockOrder({
                orderNos : sendIds
              });
            }

             this.$vs.loading.close();
            if (resp.succ == 1) {
              this.popupActiveLock = false;
              let successText = isLock ? '锁定成功' : '取消锁定成功';
              this.$notifySuccess(successText);
              this.getOrderformList();
            } else {
              this.$notifyError(resp.error);
              this.popupActiveLock = false;
            }
        },
        // 确认取消
        cancelAffirm(tr,indextr){
            this.$vs.dialog({
            type: "confirm",
            title: `实付与成交金额不同，请确认是否继续审核：`,
            text: `金额不同继续审核，订单将会转异常`,
            acceptText: "继续审核",
            cancelText: "取消",
            accept: () => {
              this.verifyConfirm(tr,indextr);
            },
        });
        },
        // ========================== 表头多选操作
        // 判断金额实付与订单总金额是否一致
        priceCompare(tr,indextr){
            if (tr.orderNo) {
                 const temp = this.orderdatalist.filter(item => item.orderNo == tr.orderNo)
                if (temp) {
                    if (temp[0].toPayPrice != temp[0].realityTotalPrice) {
                      return this.cancelAffirm(tr,indextr)
                    } else {
                        this.verifyConfirm(tr,indextr);
                    }
                }
            }
        },
        // 审核确认
        async verifyConfirm(tr, index) {
            let sendIds = []
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.every(item => item.orderStatus !== 'TO_REVIEW');
                if (temp) {
                    return this.$notifyError('选择的订单中有不可审核的订单，请重新选择');
                }
                sendIds = this.Orderselected.map(item => item.orderNo)
            } else {
                this.clickOrderNo = tr.orderNo
                sendIds = [tr.orderNo];
            }

            //只用来做判断 无实际用途
            OrderApi.reviewDetail({orderNos: sendIds}).then(res => {
                console.log(res)
                if (res.succ === 1) {
                    this.verifyConfirmId = sendIds
                    //清空
                    this.deliverParam = {
                        wsId: '',
                        locId: ''
                    }
                    this.skuCodes = [];
                    this.stockData = [];
                    // await this.getMainList();
                    // await this.handleReviewDetail(sendIds)
                    this.$vs.loading.close();
                    this.reviewOrders = sendIds;
                    this.$refs.sendReview.open(sendIds);
                    //
                }else{
                    this.$notifyError(res.error);
                }
            })

        },
        //判断单据是否有非总部
        getExtraOrder(){
          const extraOrder = this.Orderselected.every(item => !item.sellerIsMe);
          let flag = true;
          if (extraOrder) {
            this.$notifyError('存在总部不可操作的订单，请重新选择');
            flag = false;
          }
          return flag;
        },
        // 取消审核
        cancelVerifyConfirm(tr){
            this.OrderReviewselected = tr;
            this.popupActive2Qxsh = true;
        },
        async handleReviewDetail(sendIds) {
            const res = await OrderApi.reviewDetail({orderNos: sendIds})
            if(res.succ === 1) {
                this.stockData = res.result
                this.stockData = res.result.map(item => {
                    return {
                        ...item,
                        newSendSkuName: '',
                        newSendAmount: ''
                    }
                })
                if(this.stockData[0].wsId && this.stockData[0].wsLocId && this.stockData[0].wsLocName && this.stockData[0].wsName){
                    this.isSearchShow = false;
                    this.examParam.wsId = this.stockData[0].wsId;
                    this.examParam.locId = this.stockData[0].wsLocId;
                    this.deliverFlag = true;
                }else{
                    this.isSearchShow = true;
                }
                this.stockData.map(item => {
                    if(item.orderReviewDetailBoList && !this.isSearchShow){
                        item.orderReviewDetailBoList.map(ele => {
                            if(Number(ele.actualAmount) >= Number(ele.sendAmount)){
                                ele.tdClass = 'text-success';
                            }else{
                                ele.tdClass = 'text-danger';
                            }
                        })
                        // let array = item.orderReviewDetailBoList.filter(ele => ele.actualAmount < ele.sendAmount);
                        // array = array.concat(array);
                        // if(array.length > 0){this.deliverFlag = false;}else{this.deliverFlag = true;}
                    }
                })
                this.stockTabledata = this.stockData;
                this.skuCodes = this.stockData.map(item =>{
                    return item.skuCode;
                });
                if(res.result[0].bodyId && this.isSearchShow){
                    this.deliverParam.bodyId = res.result[0].bodyId;
                    this.getMainOptions(res.result[0].bodyId);
                    this.isBodyId = true;
                }
                this.judgeShqr = false;
                this.popupActive2Shqr = true;
            }else{
                this.$notifyError(res.error);
            }
        },
        // 取消推单
        cancelDriveOrder(tr){
                this.OrderDriveselected = tr;
                if (this.OrderDriveselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
            this.popupActive2Qxtd = true;
        },
        // 取消订单
        cancelOrder(tr, index) {
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.filter(item => item.orderStatus === 'SEND_ED' || item.orderStatus === 'RECEIV_ED' || item.orderStatus === 'ABNORMAL');
                if (temp.length) {
                    return this.$notifyError('选择的订单中有不可取消的订单，请重新选择');
                }
            } else {
                this.clickOrderNo = tr.orderNo;
            }
            this.popupActive2Qxdd = true;
            this.judgeQxdd = false;
        },
        // 转异常
        toAbnormal(tr, index) {
            console.log(this.Orderselected);
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                //不可转异常的订单
                let disabledList = ['SEND_ED','RECEIV_ED','CANCEL_ED','ABNORMAL']
                const temp = this.Orderselected.some(item => disabledList.indexOf(item.orderStatus) !== -1);
                if (temp) {
                    return this.$notifyError('存在不支持此类型操作的订单');
                }

                let orderTypes = Array.from( new Set(this.Orderselected.map(item => item.orderStatus)) )
                if(orderTypes.length > 1){
                    return this.$notifyError('存在不同状态的订单，不能统一执行此类型操作');
                }
            } else {
                this.clickOrderNo = tr.orderNo;
            }
            this.judgeZyc = false;
            this.popupActive2Bzyc = true;
        },
        // 转正常
        toNormal(tr, index) {
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.some(item => item.orderStatus !== 'ABNORMAL');
                if (temp) {
                    return this.$notifyError('请选择异常订单');
                }
            } else {
                this.clickOrderNo = tr.orderNo;
            }
            this.popupActive2Zzc = true;
        },

        // ============================ 列表相关
        //更改每页条数
        handleSizeChange(val){
          this.page.pageSize = val;
          this.getOrderformList();
        },
        handleCurrentChange(val){
          this.page.pageNo = val;
          this.getOrderformList();
        },
        //订货单列表查询
        async getOrderformList() {
            this.$vs.loading();
            // this.getBaseTime();
            let data = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                data: this.searchData
            }
            if(this.tabIndex == 0 && !this.searchData.buyerType){
                data.data.dealerTypeList = [];
            }
            if(this.searchData.buyerType == '门店客户'){
                // data.data.buyerType = '';
            }
            if(this.searchData.tabIndex !== 0){
                this.searchData.dealerTypeList = this.searchData.dealerTypeList.length === 0 ?['']:this.searchData.dealerTypeList;
            }

            // let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
            // this.orderSearchInfo = JSON.parse(searchInfo)  //从详情带过来的查询条件
            //   判断是否从详情页返回，如果是就保留之前查询条件

            let res = await OrderApi.OrderInvoList(data);
            //增加币种
            if(res.code == 0 && res.succ == 1){
                let resData = res.result.list;
                if(resData.length){
                resData = resData.map(data =>{
                    let currSku = data.skuItems;
                    if(currSku.length > 0){ //获取金额标识符
                    let currCurrency = data.skuItems ? data.skuItems[0].currency : this.currencyTypeList[0].id;
                    let cIndex = this.currencyTypeList.findIndex(item => item.id == currCurrency);
                    data.currency = cIndex > -1 ?  currCurrency : this.currencyTypeList[0].id;
                    cIndex = cIndex > -1 ? cIndex : 0;
                    data.currencySymbol = this.currencyTypeList[cIndex].symbol;
                    }
                    return data;
                });
                }
                resData.forEach(item=>{
                    if(item.sendWs && (item.sendWs == '深圳办公仓库' || item.sendWs == '北京办公仓库'|| item.sendWs == '深圳办公室仓（雾以希面膜）' || item.sendWs == '湖南仓（力当家口香糖）' || item.sendWs == '蚌埠仓(力当家口香糖）' || item.sendWs == '蚌埠仓'  || item.sendWs == '货代仓（AMYOOZ主体）' || item.sendWs == '货代仓（蚌埠主体）' || item.sendWs == '蚌埠工厂') && item.orderStatus === 'PUSHED'){
                        item.showBtn = true;
                    }else if(item.sendWs && item.sendWs.indexOf('虚拟仓') !== -1 && item.orderStatus === 'PUSHED'){
                        item.showBtn = true;
                    }else {
                        item.showBtn = false;
                    }
                })
                this.orderdatalist = resData;

                console.log(this.orderdatalist)
                this.page.totalCount = res.result.totalCount;
            }else{
                this.$notifyError(res.error);
                this.orderdatalist = [];
                this.page.totalCount = 0;
            }

            this.$vs.loading.close();
        },
        orderThStyle(thname) {
            let style = ''
            if(thname == "实付" || thname == "应付"){
                style = 'price-right'
            } else {
                style = 'fixed-table-column whit'
            }
            return style;
        },
        orderStatusColorStyle(status) {
            const statusMaps = [
                {
                    key: 'TO_PAY',
                    style: 'background: #A1A7B4'
                },
                {
                    key: 'TO_REVIEW',
                    style: 'background: #FF8D23'
                },
                {
                    key: 'TO_SEND',
                    style: 'background: #9254DE'
                },
                {
                    key: 'SEND_ED',
                    style: 'background: #3691FF'
                },
                {
                    key: 'PUSHED',
                    style: 'background: #5CDBD3'

                },
                {
                    key: 'RECEIV_ED',
                    style: 'background: #2DC44B'
                },
                {
                    key: 'CANCEL_ED',
                    style: 'background: #A1A7B4'
                },
                {
                    key: 'SPLIT_ORDER',
                    style: 'background: #A1A7B4'
                },
                {
                    key: 'ABNORMAL',
                    style: 'background: #FF433D'
                },
                {
                    key: 'COMBINE_ED',
                    style: 'background: #A1A7B4'
                }
            ]
            // const statusInfo =  this.orderStatusList.find(item => item.value === status)
            const map = statusMaps.find(item => item.key === status)
            if(map) {
                return map.style
            }
        },

        // 点击编辑
        handleEdit(str, index) {
            // this.addPopupActive = true
            // this.detailDataList = str
        },
        // 查看
        handleCheck(str, index, editFlag) {
            sessionStorage.setItem('detail', JSON.stringify(str));
            sessionStorage.setItem('editFlag', editFlag);
            sessionStorage.setItem('orderTypeEdit', 'invoice')
            // this.$router.push({ path: '/modules/order/invoiceDetail' }).catch(() => {});
            this.$refs.invoiceDetail.getData()

        },

        // 弹窗相关
        // 关闭查看。编辑弹窗
        close() {
            this.addPopupActive = false;
        },

        //渠道列表
        async getChannelList() {
            let res = await OrderApi.ChannelList({});
            this.OrdermanuallyArr.ChannelListArr = res.result;
            this.TreeChannel = res.result;
        },
        //支付方式
        async getPaysList() {
            let res = await OrderApi.PaysList({});
            this.OrderDetailArr.PaysListArr = res.result;
        },

        //异常标注类型列表
        async getAbnormalList() {
            let res = await OrderApi.AbnormalList({});
            this.TreeAbnormal = res.result;
        },
        // 取消推单确认
        async OncancelDriveOrder() {
            // this.popupActive2Qxtd = false;
            let orderNos = [];
            orderNos.push(this.OrderDriveselected.orderNo)
            //取消订单原因
            let res = await LogisticsApi.cancelDriveOrderChoice({
                orderNos: orderNos,
                cancelReason: this.cancelDriveModel
            });
            if (res.succ == 1) {
                this.popupActive2Qxtd = false;
                this.$notifySuccess('取消成功');
                // this.getTableData();

            } else {
                this.$notifyError(res.error);
                this.popupActive2Qxtd = false;
            }
             this.OrderDriveselected = [];
             this.cancelDriveModel = '';
             this.getOrderformList();
        },
        // 取消推单取消
        OncancelDrivebtn() {
            this.popupActive2Qxtd = false;

        },
        // 取消审核确认
        async OncancelAuditOrder(){
          this.popupActive2Qxsh = false;
          let orderNo =this.OrderReviewselected.orderNo;
          let resp = await OrderApi.onfirmOrderReview({
                orderNo
            });
            if (resp.succ == 1) {
                this.popupActive2Qxsh = false;
                this.$notifySuccess('取消成功');
                this.getOrderformList();
            } else {
                this.$notifyError(resp.error);
                this.popupActive2Qxsh = false;
            }

        //   this.getOrderformList();
        },
        // 取消审核取消
        OncancelAuditbtn(){
            this.popupActive2Qxsh = false;
        },
        //取消订单
        async OncancelOrder() {
            let orderNos = [];
            if (!this.clickOrderNo) {
                this.Orderselected.map(item => {
                    orderNos.push(item.orderNo);
                    return item;
                });
            } else {
                orderNos.push(this.clickOrderNo);
            }
            let res = await OrderApi.cancelOrderChoice({
                orderNos: orderNos,
                warnMessage: this.cancelModel
            });
            if (res.succ == 1) {
                this.popupActive2Qxdd = false;
                this.$notifySuccess('取消成功');
                // this.getTableData();
            } else {
                this.$notifyError(res.error);
                this.popupActive2Qxdd = false;
            }
            this.clickOrderNo = '';
            this.Orderselected = [];
            this.getOrderformList();
        },

        //取消取消订单
        Oncancelbtn() {
            this.clickOrderNo = '';
            this.popupActive2Qxdd = false;
        },
        //添加手工支付
        async OnOrderAddPay() {
            if (this.addpaytitle.paySource == '' || this.addpaytitle.payTime == '' || this.addpaytitle.payBillNo == '' || this.addpaytitle.totalPrice == '') {
                this.$notifyError('请将数据填写完整');
                return;
            }
            let res = await OrderApi.OrderAddPay({
                orderNo: this.detailDataList.orderNo,
                paySource: this.addpaytitle.paySource,
                payTime: this.addpaytitle.payTime + ` 00:00:00`,
                payBillNo: this.addpaytitle.payBillNo,
                totalPrice: this.addpaytitle.totalPrice
            });
            if (res.succ == 1) {
                this.popupActive2Sjzf = false;
                this.$notifySuccess('添加手工支付成功');
                // this.detailDataList.orderNo=''
                // this.addpaytitle.paySource=''
                // this.addpaytitle.payTime=''
                // this.addpaytitle.payBillNo=''
                // this.addpaytitle.totalPrice=''
                // this.getTableData();
            } else {
                this.$notifyError(res.error);
                this.popupActive2Sjzf = false;
            }
        },

        //点击转异常
        iconabnormal() {
            this.judgeZyc = true;
            this.popupActive2Bzyc = true;
        },

        //确认转异常
        async OnOrderAbnormal() {
            let orderNos = [];
            console.log(this.Orderselected,this.clickOrderNo);
            if (!this.clickOrderNo) {
                this.Orderselected.map(item => {
                    orderNos.push(item.orderNo);
                    return item;
                });
            } else {
                orderNos.push(this.clickOrderNo);
            }
            let TreeAbnormal = this.TreeAbnormal
            const AbnormalModel = TreeAbnormal.filter(item => {
                if(item.key == this.AbnormalModel) {
                    return item
                }
            })
            let res = await OrderApi.OrderAbnormalChoice({
                orderNos: orderNos,
                warnMessage: AbnormalModel[0].val   //转异常描述
                // warnMessage: AbnormalModel[0].key  //转异常编码
            });
            if (res.succ == 1) {
                this.popupActive2Bzyc = false;
                this.AbnormalModel = ''
                this.$notifySuccess('标注成功');
            } else {
                this.AbnormalModel = ''
                orderNos = []
                this.$notifyError(res.error);
                this.popupActive2Bzyc = false;
            }
            this.clickOrderNo = ''
            this.Orderselected = [];
            this.getOrderformList();
            return;
        },
        //取消转异常
        OrderAbnormalbtn() {
            this.popupActive2Bzyc = false;
        },

        // 确认转正常
        async OnNormalOk() {
            let orderNos = [];
            if (!this.clickOrderNo) {
                this.Orderselected.map(item => {
                    orderNos.push(item.orderNo);
                    return item;
                });
            } else {
                orderNos.push(this.clickOrderNo);
            }
            let res = await OrderApi.OrderTonormal({
                orderNos: orderNos
            });
            if (res.succ == 1) {
                this.$notifySuccess('转正常成功');
            } else {
                this.$notifyError(res.error);
            }
            this.popupActive2Zzc = false;
            this.clickOrderNo = '';
            this.Orderselected = [];
            this.getOrderformList();
        },
        //取消转正常
        normalbtn() {
            this.popupActive2Zzc = false;
        },

        // 调接口获取发货弹窗详情
        async getSentDetail(sendIds) {
            const res = await OrderApi.queryDeliveryOrder({orderNos: sendIds})
            if(res.succ === 1) {
                this.sendData = res.result;
                this.sendData.forEach(item=>{
                    item.isPod = false;
                })
            }
        },


        // ----------------------------发货相关
        // 批量选择运费模板
        batchSelectTemplate() {
            this.batchSelectTemplateVisible = true
        },
        //批量选择签回单
        batchSelectPod(){
            // console.log(this.sendData,this.batchSelected);
            // let isOpenFlag = this.sendData.findIndex((item)=>{
            //     return item.isPod = false;
            // })
            // if(isOpenFlag){
            //     this.$notifyError('只能批量设置顺丰仓的签回单操作')
            // }else{
            //     this.podModal = true;
            //
            // }
            this.podModal = true;
        },
        handleBatchSelect() {
            this.batchSelected = this.batchSelected.map(item => {
              item.frtId = this.batchFrtId
              const currIndex = this.sendData.findIndex(selected => selected.locName == item.locName && selected.wsName == item.wsName);
              this.$set(this.sendData, currIndex, {...this.sendData[currIndex], frtId: this.batchFrtId});
              return item;
            })
            this.batchFrtId = ''
            this.batchSelectTemplateVisible = false
        },
        handleBatchPod(){
            console.log(this.batchSelected)
            this.batchSelected = this.batchSelected.map(item => {
                item.isPod = this.isPod
                const currIndex = this.sendData.findIndex(selected => selected.locName == item.locName && selected.wsName == item.wsName && selected.orderNo == item.orderNo);
                console.log(currIndex);
                if(this.sendData[currIndex].wsName.indexOf('顺丰仓') === -1){
                    item.isPod = false;
                }
                this.$set(this.sendData, currIndex, {...this.sendData[currIndex], isPod: this.sendData[currIndex].wsName.indexOf('顺丰仓') === -1?false:this.isPod});
                console.log(this.sendData);
                return item;
            })
            console.log(this.batchSelected);
            this.isPod = false;
            this.podModal = false
        },
        cancelhandleBatch(){
           this.batchFrtId = ''
           this.batchSelectTemplateVisible = false
        },
        cancelIspod(){
            this.batchFrtId = ''
            this.podModal =false;
        },
        //发货
        async handleSend(tr, index) {
            console.log(tr, index)
            this.tuidanid = tr.id
            let sendIds = []
            this.getTmsFrtOptions();
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.some(item => item.orderStatus !== 'TO_SEND');
                if (temp) {
                    return this.$notifyError('请选择待发货订单');
                }
                const sellerIsMe = this.Orderselected.some(item => !item.sellerIsMe);
                if(sellerIsMe) {
                    return this.$notifyError('请选择总部待发货订单');
                }
                sendIds = this.Orderselected.map(item => item.orderNo)
            } else {
                sendIds = [tr.orderNo];
            }
            this.getSentDetail(sendIds)
            this.batchSelected = []
            this.showDeliverPop = true;
        },
        // 批量换商品 todo
        handleExchange(tr, index){
            //   let sendIds = []
            this.exchangeOrderNo = []
               if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.some(item => item.orderStatus !== 'TO_REVIEW');
                if (temp) {
                    return this.$notifyError('请选择待审核订单');
                }
                console.log(this.Orderselected)
                let taachedr=FontFaceSetLoadEvent
                this.Orderselected.map(item=>{
                  if(this.Orderselected[0].bodyId!=item.bodyId){

                    taachedr=true
                  }
                })
                if(taachedr==true){
                  this.$notifyError('请选择相同主体的订单');
                  return false
                }
                // 待审核订单中仅下单给总部的订单 todo
                const sellerIsMe = this.Orderselected.some(item => !item.sellerIsMe);
                if(sellerIsMe) {
                    return this.$notifyError('请选择总部订单');
                }
                this.exchangeOrderNo = this.Orderselected.map(item => item.orderNo)
            } else {
                this.exchangeOrderNo = [tr.orderNo];
            }
             this.showExchange = true;

        },
        //模糊搜索获取sku信息
        async searchInputSuggest(value) {
            // this.$refs['commodityExchangeSuggest'].searchQuery ='';
            if (value != "") {
                let data ={
                  type: 'old',
                  suggest:value,
                  orderNos:this.exchangeOrderNo
                }
                let res = await CommodityGoodsyApi.suggestSkuGoods(data);
                this.goodsOptions = res.result==null?[]:res.result;
            } else {
                this.goodsExchangeOptions = []
            }
        },
        // 替换商品的goodsOptions
         async exchangeInputSuggest(value) {
            if (value == "") {
                this.selectExchange = {}
                this.$refs['commodityExchangeSuggest'].searchQuery ='';
                // return this.$notifyError('请输入替换商品');
            } else {
              let data ={
                  type: 'new',
                  suggest:value,
                  orderNos:this.exchangeOrderNo
                }
                let res = await CommodityGoodsyApi.suggestSkuGoods(data);
                this.goodsOptions2 = res.result==null?[]:res.result;
                // const list = this.goodsOptions2.filter(good => good.skuCode != this.oneGoodSelected.skuCode)
                // if (list.length > 0) {
                //     this.goodsExchangeOptions =list;
                // }
            }
        },
        //选择原商品
        selectOneGood(item) {
            this.oneGoodSelected = item;
            // const list = this.goodsOptions2.filter(good => good.skuCode != item.skuCode)
            // if (list.length > 0) {
            //     this.goodsExchangeOptions =list;
            // }
        },
        //选择替换商品
        selectExchangeGood(item) {
            this.selectExchange = item;
        },
        // 批量换商品
        async commodityExchange(){
            if (this.oneGoodSelected.skuCode == null) {
                return this.$notifyError('请输入原商品');
            }
            if (this.selectExchange.skuCode == null) {
                return this.$notifyError('请输入替换商品');
            }
            let list = {
                skuCode: this.oneGoodSelected.skuCode,
                skuCodeNew: this.selectExchange.skuCode,
                orderNos: this.exchangeOrderNo
            }
            const res = await OrderApi.exchangeGood(list)
            if(res.succ === 1) {
                // this.$notifySuccess('替换成功');
                // this.oneGoodSelected = {}
                // this.selectExchange = {}
                // this.$refs['commoditySuggest'].searchQuery ='';
                // this.$refs['commodityExchangeSuggest'].searchQuery ='';
                // this.showExchange = false;
                //==============调整返回架构样式，更换为el-dialog wn ====//
                this.changeGoodsModal = true;
                console.log(res.result);
                this.$nextTick(()=>{
                    this.changeGoodsData = res.result.split(";").filter(Boolean);
                })
                //================================wn==================//
                // this.$confirm(res.result,{
                //     confirmButtonText: '确定',
                //     type: 'success',
                //     showCancelButton:false,
                // }).then(() => {
                //     this.oneGoodSelected = {}
                //     this.selectExchange = {}
                //     this.$refs['commoditySuggest'].searchQuery ='';
                //     this.$refs['commodityExchangeSuggest'].searchQuery ='';
                //     this.showExchange = false;
                // })
            } else {
                // this.oneGoodSelected = {}
                // this.selectExchange = {}
                // this.$refs['commoditySuggest'].searchQuery ='';
                // this.$refs['commodityExchangeSuggest'].searchQuery ='';
                this.$notifyError(res.error);
                // this.showExchange = false;
            }
            this.getOrderformList();

        },
        //关闭&确定替换商品弹窗-wn
        closeChangeModal(){
            this.changeGoodsModal = false;
            this.oneGoodSelected = {}
            this.selectExchange = {}
            this.$refs['commoditySuggest'].searchQuery ='';
            this.$refs['commodityExchangeSuggest'].searchQuery ='';
            this.showExchange = false;
        },
        //
        cancelExchange(){
            this.oneGoodSelected = {}
            this.selectExchange = {}
            this.$refs['commoditySuggest'].searchQuery ='';
            this.$refs['commodityExchangeSuggest'].searchQuery ='';
            this.showExchange = false;
        },
        // 确认推单
        async deliverOrder() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
            });
            const list = this.sendData.map(item => ({orderNo: item.orderNo, frtId: item.frtId ,isPod:item.isPod,id : this.tuidanid}))
            const res = await OrderApi.batchOrderSend({list})
            if(res.succ === 1) {
                this.$notifySuccess('推单成功');
                this.sendData = []
                this.Orderselected = [];
                loading.close();
                this.getOrderformList();
            } else {
                this.sendData = []
                this.Orderselected = []
                this.$notifyError(res.error);
                loading.close();
            }

        },
        // 取消
        cancelDeliverOrder(){
            this.showDeliverPop=false
            this.sendData = []
            // this.Orderselected = []
        },
        //拆单
        async handleSeparateBillAll(tr, index){
            let list = []
            let currSkuItems = []
            let orderNos = []
            if (index === undefined) {
                if (this.Orderselected.length === 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.filter(item => (item.orderStatus !== 'TO_REVIEW' && item.orderStatus !== 'ABNORMAL') || item.seller != 1);
                if (temp.length) {
                    return this.$notifyError('选择的订单中有不可拆分的订单，请重新选择');
                }
                orderNos = this.Orderselected.map(item => item.orderNo)
            } else {
                orderNos.push(tr.orderNo)
            }
            let data = {
              orderNos: orderNos
            }
            //获取拆单列表
             let res = await OrderApi.getBatchOrderSplit(data);
            //let res = {"code":0,"error":"","result":[{"id":null,"parentOrderNo":null,"orderNo":"10117975698837842-2","invoiceNo":null,"billNo":null,"orderNos":null,"orderBillId":null,"orderBillNo":null,"outOrderBillNo":null,"orderTime":null,"payTime":null,"buyer":null,"seller":null,"buyerName":null,"buyerType":null,"buyerCode":null,"sellerName":null,"sellerType":null,"sellerPhone":null,"sellerCode":null,"orderStatus":null,"address":null,"province":null,"city":null,"area":null,"buyerRemark":null,"sellerRemark":null,"lockUser":null,"reviewRemark":null,"toPayPrice":"0","totalPrice":"0","transportPrice":null,"sourceChannel":null,"billSource":null,"combineType":null,"combineOpt":null,"payUser":null,"paySource":null,"paySourceList":null,"payTypeDescList":null,"paySourceDesc":"","paySourceListDesc":"","payStatus":null,"payStatusDesc":"","payBillNo":null,"orderType":null,"fromDepart":null,"fromUser":null,"warnMessage":null,"manualOrder":false,"transportNo":null,"receiveName":null,"receivePhone":null,"receiveTel":null,"wsId":null,"locId":null,"payPics":[],"skuItems":[{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"单烟杆-国内版-二代-蔚蓝星球-高亮渐变MK","count":"0","barCode":"6972092563845","skuCode":"SKU00058","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":3379,"availableAmount":3378},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":240,"availableAmount":240}]},{"skuName":"单烟杆-国内版-二代-蔚蓝星球-高亮渐变MK-60支/箱","count":"1","barCode":"6972092563876","skuCode":"SKU00135","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":116,"availableAmount":116},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00058","skuName":"单烟杆-国内版-二代-蔚蓝星球-高亮渐变MK","barCode":"6972092563845","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-橘子汽水-MK","count":"0","barCode":"6972092568406","skuCode":"SKU00322","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":551,"availableAmount":551},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-橘子汽水-MK-60盒/箱","count":"1","barCode":"6972092568505","skuCode":"SKU00265","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":14,"availableAmount":13},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00322","skuName":"陶瓷烟弹-海外通用版-2粒装-橘子汽水-MK","barCode":"6972092568406","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-冰甜蜜瓜-MK","count":"0","barCode":"6972092562039","skuCode":"SKU00332","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":292,"availableAmount":292},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-冰甜蜜瓜-MK-60盒/箱","count":"1","barCode":"6972092562046","skuCode":"SKU00277","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":94,"availableAmount":94},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00332","skuName":"陶瓷烟弹-海外通用版-2粒装-冰甜蜜瓜-MK","barCode":"6972092562039","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-灵魂薄荷-MK","count":"0","barCode":"6972092563555","skuCode":"SKU00337","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":249,"availableAmount":235},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-灵魂薄荷-MK-60盒/箱","count":"2","barCode":"6972092563579","skuCode":"SKU00282","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":141,"availableAmount":131},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00337","skuName":"陶瓷烟弹-海外通用版-2粒装-灵魂薄荷-MK","barCode":"6972092563555","num":120.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"个","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"2箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-青提汽水-MK","count":"0","barCode":"6972092560615","skuCode":"SKU00340","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":240,"availableAmount":240},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-青提汽水-MK-60盒/箱","count":"1","barCode":"6972092560622","skuCode":"SKU00285","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":299,"availableAmount":299},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00340","skuName":"陶瓷烟弹-海外通用版-2粒装-青提汽水-MK","barCode":"6972092560615","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"isGive":true,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"单烟杆-海外版-二代-淡墨灰-喷砂渐变MK","count":"47","barCode":"6972092563937","skuCode":"SKU00350","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":307,"availableAmount":304},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00350","skuName":"单烟杆-海外版-二代-淡墨灰-喷砂渐变MK","barCode":"6972092563937","num":47.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"个","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"47个"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"单烟杆-海外版-二代-淡墨灰-喷砂渐变MK","count":"13","barCode":"6972092563937","skuCode":"SKU00350","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":307,"availableAmount":304},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00350","skuName":"单烟杆-海外版-二代-淡墨灰-喷砂渐变MK","barCode":"6972092563937","num":13.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"个","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"13个"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"单烟杆-海外版-二代-迷笛时空-高亮渐变AEF","count":"0","barCode":"6972092560851","skuCode":"SKU00354","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":528,"availableAmount":525},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"单烟杆-海外版-二代-迷笛时空-高亮渐变AEF-60支/盒","count":"1","barCode":"6972092560868","skuCode":"SKU00298","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":122,"availableAmount":122},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00354","skuName":"单烟杆-海外版-二代-迷笛时空-高亮渐变AEF","barCode":"6972092560851","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"个","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"单烟杆-海外版-二代-青山颂-喷砂纯色AEF","count":"1","barCode":"6972092560813","skuCode":"SKU00366","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":686,"availableAmount":683},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00366","skuName":"单烟杆-海外版-二代-青山颂-喷砂纯色AEF","barCode":"6972092560813","num":1.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"个","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1个"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-兰花雪梨-MK","count":"0","barCode":"6972092569571","skuCode":"SKU00784","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":297,"availableAmount":297},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-兰花雪梨-MK-60盒/箱","count":"1","barCode":"6972092569588","skuCode":"SKU00783","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":122,"availableAmount":122},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00784","skuName":"陶瓷烟弹-海外通用版-2粒装-兰花雪梨-MK","barCode":"6972092569571","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-冰爽西瓜-MK","count":"0","barCode":"6972092567881","skuCode":"SKU00820","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":555,"availableAmount":555},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-冰爽西瓜-MK-60盒/箱","count":"1","barCode":"6972092567898","skuCode":"SKU00819","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":19,"availableAmount":19},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00820","skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-冰爽西瓜-MK","barCode":"6972092567881","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-致爽薄荷-MK","count":"0","barCode":"6972092568130","skuCode":"SKU00825","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":286,"availableAmount":286},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-致爽薄荷-MK-60盒/箱","count":"1","barCode":"6972092568147","skuCode":"SKU00826","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00825","skuName":"陶瓷烟弹-海外零尼古丁版-2粒装-致爽薄荷-MK","barCode":"6972092568130","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-古巴风味-MK","count":"13","barCode":"6974626650861","skuCode":"SKU00867","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":600,"availableAmount":600},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00867","skuName":"陶瓷烟弹-海外通用版-2粒装-古巴风味-MK","barCode":"6974626650861","num":13.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"13盒"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-青苹汽水-MK","count":"0","barCode":"6974626652360","skuCode":"SKU00976","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":406,"availableAmount":406},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-青苹汽水-MK-60盒/箱","count":"2","barCode":"6974626652377","skuCode":"SKU00977","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":210,"availableAmount":210},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU00976","skuName":"陶瓷烟弹-海外通用版-2粒装-青苹汽水-MK","barCode":"6974626652360","num":120.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"2箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-超级柠檬-HY","count":"0","barCode":"6974626653329","skuCode":"SKU01071","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":392,"availableAmount":392},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-超级柠檬-HY-60盒/箱","count":"1","barCode":"6974626653336","skuCode":"SKU01072","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":47,"availableAmount":47},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01071","skuName":"陶瓷烟弹-海外通用版-2粒装-超级柠檬-HY","barCode":"6974626653329","num":60.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"一次性小烟-英国版-G01-蓝莓芝士蛋糕-10支/盒","count":"0","barCode":"6974626654012","skuCode":"SKU01085","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":10,"availableAmount":9},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"一次性小烟-英国版-G01-蓝莓芝士蛋糕-100支/箱","count":"1","barCode":"6974626653206","skuCode":"SKU01020","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":299,"availableAmount":295},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01085","skuName":"一次性小烟-英国版-G01-蓝莓芝士蛋糕-10支/盒","barCode":"6974626654012","num":10.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":10,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"一次性小烟-英国版-G01-香蕉冰-10支/盒","count":"0","barCode":"6974626653992","skuCode":"SKU01087","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":10,"availableAmount":9},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"一次性小烟-英国版-G01-香蕉冰-100支/箱","count":"1","barCode":"6974626653220","skuCode":"SKU01018","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":313,"availableAmount":309},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01087","skuName":"一次性小烟-英国版-G01-香蕉冰-10支/盒","barCode":"6974626653992","num":10.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":10,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"一次性小烟-英国版-G01-薄荷-10支/盒","count":"0","barCode":"6974626653985","skuCode":"SKU01088","unit":"盒","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":8,"availableAmount":7},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]},{"skuName":"一次性小烟-英国版-G01-薄荷-100支/箱","count":"1","barCode":"6974626653237","skuCode":"SKU01017","unit":"箱","wmsStockInfos":[{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":340,"availableAmount":336},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01088","skuName":"一次性小烟-英国版-G01-薄荷-10支/盒","barCode":"6974626653985","num":10.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":10,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"1箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"陶瓷烟弹-海外通用版-2粒装-沁爽乳酸菌-HY","count":"0","barCode":"6974626654555","skuCode":"SKU01155","unit":"盒","wmsStockInfos":[{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":190,"availableAmount":190}]},{"skuName":"陶瓷烟弹-海外通用版-2粒装-沁爽乳酸菌-HY-60盒/箱","count":"2","barCode":"6974626654562","skuCode":"SKU01156","unit":"箱","wmsStockInfos":[{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":9,"availableAmount":4}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01155","skuName":"陶瓷烟弹-海外通用版-2粒装-沁爽乳酸菌-HY","barCode":"6974626654555","num":120.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":60,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"0","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"2箱"},{"wmsStockInfos":[],"wmsStockInfosBox":[],"skuNameCounts":[{"skuName":"一次性小烟-英国版-G01-可乐冰-10支/盒","count":"0","barCode":"6974626654739","skuCode":"SKU01240","unit":"盒","wmsStockInfos":[{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":17,"availableAmount":16}]},{"skuName":"一次性小烟-英国版-G01-可乐冰-100支/箱","count":"2","barCode":"6974626654692","skuCode":"SKU01239","unit":"箱","wmsStockInfos":[{"locName":"产品不良","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品国际","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品报废","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料不良","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料报废","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"物料良品","wsName":"新北京仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"北京办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"深圳办公仓库","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"嘉顺仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品废品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"京东仓（蚌埠奇雾）","isOrderDefault":"1","actualAmount":0,"availableAmount":0},{"locName":"产品良品","wsName":"顺丰国际（蚌埠奇雾）","isOrderDefault":"1","actualAmount":62,"availableAmount":58}]}],"orderNo":null,"invoiceNo":null,"id":null,"skuCode":"SKU01240","skuName":"一次性小烟-英国版-G01-可乐冰-10支/盒","barCode":"6974626654739","num":20.0,"untilPrice":0.0,"itemPrice":0.0,"headerStock":0,"imgUrl":null,"sendAvailableAmount":null,"sendActualAmount":null,"availableAmount":1,"actualAmount":1,"availableAmountBox":null,"actualAmountBox":null,"goodsCategoryName":null,"boxSpec":10,"isBoxSpec":"true","boxCode":null,"unit":"盒","currency":null,"expItemPrice":null,"expHitemPrice":null,"orderType":"1","rebeatPercent":0.0,"mappingSkuCode":null,"bodyId":null,"originOrderNo":"10117975698837842","rebeatMoney":0.0,"hunitPrice":0.0,"hitemPrice":0.0,"sendSpecNum":"2箱"}],"outerOrder":false,"sellerClientInfo":null,"billSendBo":null,"billReceiveBo":null,"approvalUserName":"","piNo":null,"payRecords":[],"childOrders":[],"originalTotalPrice":0.0,"dealTotalPrice":0.0,"actualTotalPrice":0.0,"realityTotalPrice":"0","actualTotalPriceStr":null,"discountTotalPrice":0.0,"sellerIsMe":false,"isSplitOrder":null,"skuSummary":"20种/1024件","sendWs":null,"sendLoc":null,"express":null,"sendTime":null,"configId":null,"combineOrders":[],"splitOrder":null,"rebeatPercent":0.0,"rebeatMoney":0.0,"rebeatType":null,"addrMatch":null,"orderAmount":0,"combinemini":false,"orderBillAccountDetails":null,"bodyName":null,"bodyId":null,"splitSkuCount":null,"orderPriceList":null,"updateSkuItemList":null,"totalCount":0,"totalNum":0,"pushTime":null,"userType":null,"currency":null,"orderStatusDesc":"","sourceChannelDesc":"","billSourceDesc":"","client":false}],"total":null,"succ":1}
            if (res.succ === 1) {
                res.result.map(item => {
                    item.skuItems.map(child => {
                        child.orderNo = item.orderNo;
                        child.sendWs = item.sendWs || '';
                        child.sendLoc = item.sendLoc || '';
                        child.sendAvailableAmount = item.sendAvailableAmount || 10;
                        child.sendActualAmount = item.sendActualAmount || 20;
                    })
                    currSkuItems.push(item.skuItems);
                    // item.skuItems.map(child => {
                    //     currSkuItems.push(child);
                    // })
                })
            } else {
                return this.$notifyError(res.error);
            }
            console.log(currSkuItems);
            let separator = '/';
            //获取总的仓库集合
            this.allStockList = [];
            let tTllStockList = [];
            console.log(currSkuItems)
            currSkuItems.map(item => {
                item.map(currSku => {
                    // if(currSku.sendWs && currSku.sendLoc){
                    //     tTllStockList.unshift({
                    //         id: 'stock0',
                    //         wsName: currSku.sendWs,
                    //         locName: currSku.sendLoc,
                    //         title: (currSku.sendWs || '') + '/' + (currSku.sendLoc || '')
                    //     });
                    // }
                    // else{
                        currSku.skuNameCounts.map(currSkuItem => {
                            if(currSkuItem.wmsStockInfos.length > 0){
                                currSkuItem.wmsStockInfos.map(stock => {
                                    //存储仓库总集合
                                    const stockIndex = tTllStockList.findIndex(ss => ss.wsName == stock.wsName && ss.locName == stock.locName);
                                    if(stockIndex == -1){
                                    const index = tTllStockList.length;
                                        tTllStockList.push({
                                            id: 'stock' + (index+1),
                                            wsName: stock.wsName,
                                            locName: stock.locName,
                                            title: (stock.wsName || '') + '/' + (stock.locName || '')
                                        });
                                    }
                                });
                            }
                        })
                    // }

                });

            })
            this.allStockList = tTllStockList;
            console.log(this.allStockList);
            console.log(currSkuItems);
            //格式化数据
            let formatSkuItems = [];
            currSkuItems.map(curr => {
                curr.map(item => {
                    let addSku = {};
                    addSku.orderNo = item.orderNo;
                    addSku.barCode = item.barCode;
                    addSku.skuCode = item.skuCode;
                    addSku.skuName = item.skuName;
                    addSku.num = item.num;
                    addSku.orderType = item.orderType;
                    addSku.originOrderNo = item.originOrderNo;
                    //箱规
                    addSku.boxSpec = item.boxSpec;
                    //下单数量
                    addSku.orderNum = item.num + item.unit || '';
                    let skuStockNum = 0;
                    //是否合并单元格
                    let tempSpanFlag = item.skuNameCounts.length > 1 ? true : false;
                    //存储第二行盒的数据
                    let avaTotalStockCount = 0;//可用总库存
                    let actualTotalStockCount = 0;//实际总库存

                    let secondItem = JSON.parse(JSON.stringify(addSku));

                    item.skuNameCounts.map((sku,skuIndex) => {
                        tTllStockList.map(cStock =>{
                            let stockIndex = '';
                            let tempStock = '';
                            let actAmount = '';
                            if(item.sendLoc && item.sendWs){
                                stockIndex = curr.findIndex(ws => ws.sendWs == cStock.wsName && ws.sendLoc == cStock.locName);
                                tempStock = item;
                            }else{
                                //组装箱数据
                                stockIndex = sku.wmsStockInfos.findIndex(ws => ws.wsName == cStock.wsName && ws.locName == cStock.locName);
                                tempStock = sku.wmsStockInfos[stockIndex];
                                console.log(stockIndex);
                            }
                            const tempId = cStock.id;

                            if(stockIndex == -1){
                                if(skuIndex == 0){
                                    addSku[tempId] = '-';
                                }else{
                                    secondItem[tempId] = '-';
                                }
                            }else{
                                if(item.sendLoc && item.sendWs){
                                    //箱可用库存/实际库存
                                    skuStockNum = item.sendAvailableAmount;
                                    actAmount = item.sendActualAmount;
                                }else{
                                    //箱可用库存/实际库存
                                    skuStockNum = tempStock.availableAmount || 0;
                                    actAmount = tempStock.actualAmount || 0;
                                }
                                let showStock = skuStockNum + separator + actAmount;
                                //计算总库存
                                avaTotalStockCount += Number(skuStockNum);
                                actualTotalStockCount += Number(actAmount);
                                //判断仓库颜色
                                // const stockClass = tempId + 'Class';
                                // let isFit = false;
                                // if(Number(skuStockNum) >= Number(tempStock.availableAmount)){
                                //   isFit = true;
                                // }
                                if(skuIndex == 0){
                                addSku[tempId] = showStock;
                                // addSku[stockClass] = isFit;
                                }else{
                                secondItem[tempId] = showStock;
                                // secondItem[stockClass] = isFit;
                                }
                            }
                        });



                        //总库存
                        const totalStockCount =  avaTotalStockCount + separator +actualTotalStockCount;
                        if(skuIndex == 0){
                            addSku.unit = sku.unit;
                            addSku.allStockNum = totalStockCount;
                            addSku.sendSkuBarCode = sku.barCode || '';
                            addSku.sendSkuName = sku.skuName; //发货名称
                            addSku.sendNum = sku.count || 0;
                            addSku.sendSpecNum = sku.count ? (sku.count + (sku.unit || '')) : ''; //发货数量
                            console.log(addSku);
                        }else{
                            console.log(sku);
                            secondItem.unit = sku.unit;
                            secondItem.allStockNum = totalStockCount;
                            secondItem.sendSkuBarCode = sku.barCode || '';
                            secondItem.sendSkuName = sku.skuName; //发货名称
                            secondItem.sendNum = sku.count || 0;
                            secondItem.sendSpecNum = sku.count ? (sku.count + (sku.unit || '')) : ''; //发货数量
                        }
                    });
                    console.log(addSku);
                    //是否合并单元格
                    addSku.spanFlag = tempSpanFlag;
                    if(addSku.spanFlag){
                        addSku.split = 1;
                        secondItem.split = 2;

                        formatSkuItems.push(addSku);
                        formatSkuItems.push(secondItem);

                    }else{
                        addSku.split = 0;
                        // addSku.sendSkuName = item.skuName; //发货名称
                        // addSku.sendSkuBarCode = item.barCode;
                        formatSkuItems.push(addSku);
                    }
                })
            })
            console.log(formatSkuItems);
            let dataArr = [];
            formatSkuItems.forEach(mapItem => {
                if (dataArr.length == 0) {
                    dataArr.push({ orderNo: mapItem.orderNo, skulist: [mapItem] })
                } else {
                    let res = dataArr.some(item=> {//判断相同订单号，有就添加到当前项
                        if (item.orderNo == mapItem.orderNo) {
                            item.skulist.push(mapItem)
                            return true
                        }
                    })
                    if (!res) {//如果没找相同日期添加一个新对象
                        dataArr.push({ orderNo: mapItem.orderNo, skulist: [mapItem] })
                    }
                }
            });
            // console.log(dataArr);
            // let obj = {};
            // let someArr = [];
            // let arrBarCode = dataArr[0].skulist.map(item => item.barCode);
            // console.log(arrBarCode);
            // let arr = dataArr[0].skulist.reduce((cur, next,index) => {
            //     var key = next.barCode
            //     obj[key] ?cur.push(next): obj[key] = true
            //     return cur;
            // }, [])
            // console.log(arr);
            // arr.forEach(item=>{
            //     if(item.split === 0){
            //         item.isSome = true;
            //         someArr.push(item);
            //     }
            // })
            // console.log(someArr);
            // dataArr[0].skulist.forEach(item=>{
            //     someArr.forEach(v=>{
            //         if(item.num === v.num && item.barCode === v.barCode){
            //             item.isSome = true;
            //         }
            //     })
            // })
            this.breakUpOrderList =dataArr;
            this.currentOrderNo = tr.orderNo;
            this.breakUpOrderShow = true;
        },
        //相同订单号添加标识区分
        addOrderFlag(arr){
            let obj = {};
            let someArr = [];
            let result = arr.skulist.reduce((cur, next,index) => {
                var key = next.barCode
                obj[key] ?cur.push(next): obj[key] = true
                return cur;
            }, [])
            result.forEach(item=>{
                if(item.split === 0){
                    item.isSome = true;
                    someArr.push(item);
                }
            })
            arr.skulist.forEach(item=>{
                someArr.forEach(v=>{
                    if(item.num === v.num && item.barCode === v.barCode){
                        item.isSome = true;
                    }
                })
            })
            return arr;
        },
        // sku拆单
        async handleSeparateBillSku(){
            let list = []
            let currSkuItems = []
            let orderNos = []
            if (this.Orderselected.length == 0) {
                return this.$notifyError('请选择订单');
            }

            //校验是否是总部可操作的状态
            if(!this.getExtraOrder()){
                return false;
            }
            const temp = this.Orderselected.filter(item => (item.orderStatus !== 'TO_REVIEW' && item.orderStatus !== 'ABNORMAL') || item.seller != 1);
            if (temp.length) {
                return this.$notifyError('选择的订单中有不可拆分的订单，请重新选择');
            }
            const numcount = this.Orderselected.filter(item => (item.totalCount == 1 && item.totalNum == 1));
            console.log(numcount)

            if(numcount.length){
                return this.$notifyError('选择的订单中有不可拆分的订单，请重新选择');
            }
            orderNos = this.Orderselected.map(item => item.orderNo)

            let data = {
              orderNos: orderNos
            }
            //获取sku拆单验证
            let res = await OrderApi.splitOrderBySkuCheck(data);
            if(res.code == 0 && res.succ == 1){
                this.breakUpOrderSkuShow = true;
            }else{
                return this.$notifyError(res.error);
            }
        },
        /* 仓位库存颜色判断逻辑：
         * 需求：判断每个仓位可用库存是否大于发货数量，如果仓位库存大于/等于发货数量，显示绿色；
         * 逻辑：库存是否充足判断：（如发货数量5箱10盒）
         *  箱库存大于等于发货数量的箱（即>= 5） && 盒库存大于等于发货数量的盒（即>=10）
         * 如果小于，显示黑色；
         * sendSku: 发货箱数量
         * sendSkuBox: 发货盒数量
         * skuStock: 当前仓位箱库存
         * skuBoxStock: 当前仓位盒库存
         * boxSpec: 箱规
         */
        currStockFit(sendSku, sendSkuBox, skuStock, skuBoxStock, boxSpec){
          let fitFlag = false;
          if(Number(skuStock) >= Number(sendSku) && Number(skuBoxStock) >= Number(sendSkuBox)){
            fitFlag = true;
          }
          return fitFlag;
        },
        //合并订单
        handleCombineBill(tr, index){
          this.combineOrderShow = true;
          this.currCombineOrderInfo = tr;
          // this.$refs.combineOrder.checkedType = [];
          // this.$refs.combineOrder.searchCanComineList();
        },
        //获取主体
        async getMainList(){
            let resp = await WmsWarehouseApi.getAllMainBody({});
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                this.mainOptions = result.map(item => {
                    let obj = {};
                    obj.id = item.id;
                    obj.label = item.name;
                    return obj;
                });
            }
        },
        //获取分仓
        async getMainOptions(id,flag) {
            let bodyId = id || this.deliverParam.bodyId;
            if(bodyId){
                let resp = await WmsWarehouseApi.getWarehouseAll({
                    bodyId:bodyId,
                    suggest: '',
                    type: Mod_Warehouse_Types_Options[2].id
                });
                this.distOptions = resp.result.map(item => {
                    let obj = {};
                    obj.id = item.wsId;
                    obj.label = item.wsName;
                    return obj;
                });
                if(!flag) {
                    this.$set(this.deliverParam, 'wsId', '')
                    this.$set(this.deliverParam, 'locId', '')
                }
            }
        },
        //获取仓位
        async getLocOptions(id, flag) {
            let wsId = id || this.deliverParam.wsId;
            this.deliverParam.locId = '';
            if (wsId){
                let resp = await WmsWarehouseApi.getLocAll({
                    wsId: wsId
                });
                this.locOptions = resp.result
                    ? resp.result.map(item => {
                          let obj = {};
                          obj.id = item.id;
                          obj.label = item.locName;
                          return obj;
                      })
                    : [];
                if(!flag) {
                    this.$set(this.deliverParam, 'locId', '')
                }
            }
        },
        //获取所有运费模板
        async getTmsFrtOptions() {
            let resp = await LogisticsApi.getTmsFrtOptions({ suggest: '' });
            if (resp.succ == 1 && resp.result) {
                this.tmsFrtOptions = resp.result.map(item => {
                    let obj = {};
                    obj.id = item.id;
                    obj.label = item.name;
                    return obj;
                });
            }
        },

        //编辑卖家备注
        editBuyerRemark(tr) {
            this.sellerRemark = tr.sellerRemark;
            this.clickOrderNo = tr.orderNo;
            this.sellerRemarkPop = true;
        },
        //保存卖家备注
        async saveSellerRemark() {
            if (this.sellerRemark == '') {
                this.$notifyError('请填写备注信息');
            } else if (this.clickOrderNo == '') {
                this.$notifyError('订单编号获取失败');
            } else {
                let res = await OrderApi.updateOrderInfo({
                    orderNo: this.clickOrderNo,
                    sellerRemark: this.sellerRemark
                });
                this.sellerRemarkPop = false;
                if (res.succ == 1) {
                    this.$notifySuccess('保存成功');
                    this.sellerRemark = '';
                    this.getOrderformList();
                } else {
                    this.$notifyError(res.error);
                }
            }
        },
        async download() {
            //组装下载参数
            // let param = {
            //     sourceChannelList: this.searchData.sourceChannelList,
            //     startTime: this.searchData.fromDate,
            //     endTime: this.searchData.toDate,`            ·
            //     orderStatusList: this.searchData.orderStatusList,
            //     orderNo: this.searchData.orderNo,
            //     supplierType: this.searchData.supplierType,  //买家类型
            //     dealerType: this.searchData.dealerType,  //买家类型
            //     buyerType: this.searchData.buyerType, //左侧筛选条件：买家类型
            //     buyer:this.searchData.buyer, //左侧筛选的买家
            //     bodyId: this.searchData.bodyId, //主体名称
            //     dealerTypeList: this.searchData.dealerTypeList
            // };
            let param = this.searchData
            if(this.Orderselected.length != 0){
                let orderNos = this.Orderselected.map(item => { return item.orderNo })
                param.orderNos = orderNos;
            }
            // console.log(this.searchData)
            let url = '/data-dist/api/dist/ordering/export/order';
            let fileName = '订单列表导出.xlsx';
            // downloadExcel(url, param, fileName);

            const res = await OrderApi.orderdaofah(param)
            if(res.code=='0'){
                this.$notifySuccess(res.result)
            }else{
                this.$notifyError(res.error);
            }
        },
        //下载文件模板
        downloadTemplate(){
            downloadFileTemplate('/data-dist/api/dist/down/template/yooz_ordering', '订单导入模板.xlsx');
        },

        //拆单成功回调
        handleBreakUpOrderSuccess(){
            this.getOrderformList();
            this.$notifySuccess('拆单成功');
        },

        //合单成功回调
        //拆单成功回调
        handleCombineOrderSuccess(){
          this.getOrderformList();
          this.$notifySuccess('合并订单成功');
        },

        /********  订货单二期功能 ************* */
        //单个订单审核
        examineOrder(){
            let that = this;
            that.isExamineOrder = true;
        },
        handleSelectionChange(){

        },
        // 分配仓库
        distWare(){
            let that = this;
            let orderNos = []
            if (this.Orderselected.length == 0) {
                return this.$notifyError('请选择订单');
            }
            //校验是否是总部可操作的状态
            if(!this.getExtraOrder()){
                return false;
            }
            const temp = this.Orderselected.filter(item => item.orderStatus !== 'TO_REVIEW');
            if (temp.length) {
                return this.$notifyError('选择的订单中有不可分配的订单，请重新选择');
            }
            orderNos = this.Orderselected.map(item => item.orderNo)
            that.wareOrderNos = orderNos;
            that.getDistWareList(orderNos);
        },
        //获取分配仓库列表
        async getDistWareList(orderNos){
            let that = this;
            let params = {orderNos: orderNos}
            let resp = await OrderApi.setOrderWsIdQuery(params);
            if(resp.code == 0 && resp.succ == 1){
                that.wareList = resp.result;
                that.warePopupDialog = true;
            }else{
                that.$notifyError(resp.error);
            }
        },
        //选择仓库获取仓位
        async selectWare(id){
            this.locOptions = [];
            this.locSecId = '';
            this.getLocOptions(id);
        },
        //分配仓库列表
        async warePopupConfirm(){
            let that = this;
            let params = {
                wsId: that.wareSecId,
                locId: that.locSecId,
                orderNos: that.wareOrderNos
            };
            let resp = await OrderApi.setOrderWsId(params);
            if(resp.code == 0 && resp.succ == 1){
                that.$notifySuccess('保存成功');
                that.wareSecId = '';
                that.locSecId = '';
                that.Orderselected = [];
                that.getOrderformList();
                that.warePopupDialog = false;
            }else{
                that.$notifyError(resp.error);
            }
        },
        // 改变发货数量
        changInputSec(tr, orderNo){
            console.log(tr.newSendAmount);
            console.log(orderNo)
            let that = this;
            that.stockTabledata.map(item => {
                if(!that.isSearchShow){
                    item.orderReviewDetailBoList.map(child => {
                        if(child.sendSkuCode == tr.sendSkuCode && orderNo == tr.orderNo){
                            child.sendAmount = tr.sendAmount;
                            child.actualAmountEnd = Number(tr.actualAmount) - Number(tr.sendAmount)
                            if(child.actualAmountEnd >= 0){
                                child.tdClass = 'text-success';
                                child.remark = '';
                                that.deliverFlag=true;
                            }else{
                                child.tdClass = 'text-danger';
                                child.remark = '当前仓库库存不足';
                                //不可以发货
                                that.deliverFlag=false;
                            }
                            if(!tr.sendAmount || tr.sendAmount > child.actualAmountEnd || tr.sendAmount < 0){
                                child.tdClass = 'text-danger';
                                that.deliverFlag=false;
                            }
                        }else{
                            if(!child.sendAmount || child.sendAmount > child.actualAmountEnd || child.sendAmount < 0){
                                child.tdClass = 'text-danger';
                                that.deliverFlag=false;
                            }
                        }
                    })
                }else{
                    let img = tr.orderAmount.substring(0, tr.orderAmount.length - 1);
                    let listnum

                    if(tr.boxUnit=="箱"){
                       listnum = Number(tr.newSendAmount)*Number(tr.boxUnitSum)
                       if(Number(listnum)!=img||Number(tr.newSendAmount)>Number(tr.actualAmount)){
                            console.log(listnum,img,tr.actualAmount)
                            tr.tdClass = 'text-danger';
                            that.deliverFlag=false;
                        }else{
                            tr.tdClass = 'text-success';
                            tr.remark = '';
                            that.deliverFlag=true;
                        }
                    }else{
                        if(Number(tr.newSendAmount)!=img||Number(tr.newSendAmount)>Number(tr.actualAmount)){
                            console.log(listnum,img,tr.actualAmount)
                            tr.tdClass = 'text-danger';
                            that.deliverFlag=false;
                        }else{
                            tr.tdClass = 'text-success';
                            tr.remark = '';
                            that.deliverFlag=true;
                        }
                    }

                    // item.wmtrsOrderReviewStockBoList.map(child => {
                        // console.log(child)

                        // if(child.sendSkuCode == tr.sendSkuCode && orderNo == tr.orderNo){
                        //     child.newSendAmount = tr.newSendAmount;
                        //     child.actualAmountEnd = Number(tr.actualAmount) - Number(tr.newSendAmount)
                        //     if(child.actualAmountEnd >= 0){
                        //         child.tdClass = 'text-success';
                        //         child.remark = '';
                        //         that.deliverFlag=true;
                        //     }else{
                        //         child.tdClass = 'text-danger';
                        //         child.remark = '当前仓库库存不足';
                        //         //不可以发货
                        //         that.deliverFlag=false;
                        //     }
                        //     if(!tr.newSendAmount || tr.newSendAmount > child.actualAmountEnd || tr.newSendAmount < 0){
                        //         child.tdClass = 'text-danger';
                        //         that.deliverFlag=false;
                        //     }
                        // }else{
                        //     if(!child.newSendAmount || child.newSendAmount > child.actualAmountEnd || child.newSendAmount < 0){
                        //         child.tdClass = 'text-danger';
                        //         that.deliverFlag=false;
                        //     }else{
                        //        if(Number(tr.newSendAmount)>(tr.orderAmount)||Number(tr.newSendAmount)>Number(tr.actualAmount)){

                        //            tr.tdClass = 'text-danger';
                        //             that.deliverFlag=false;
                        //        }else{
                        //            child.tdClass = 'text-success';
                        //         child.remark = '';
                        //         that.deliverFlag=true;
                        //        }

                        //     }
                        // }
                    // })
                }
            })
        },

          //订单审核确认
        async OnconfirmOrder() {
            let that = this;
            let orders = []
            that.stockTabledata.map(item => {
                let obj = {};
                let array = [];
                obj.orderNo = item.orderNo;
                obj.wsId = that.deliverParam.wsId || that.examParam.wsId;
                obj.locId = that.deliverParam.locId || that.examParam.locId;
                item.orderReviewDetailBoList.map(child => {
                    console.log(child)
                    let childObj = {};
                    childObj.skuCode = child.skuCode;
                    // if(that.isSearchShow){
                    //     if(child.sendBoxUnit == '盒'){
                    //         childObj.caseNum = child.newSendAmount;
                    //     }else{
                    //         childObj.boxNum = child.newSendAmount;
                    //     }
                    // }else{
                    //     if(child.sendSkuUnit == '盒'){
                    //         childObj.caseNum = child.sendAmount;
                    //     }else{
                    //         childObj.boxNum = child.sendAmount;
                    //     }
                    // }
                    if(that.isSearchShow){
                        if(child.sendBoxUnit == '箱'){
                            childObj.boxNum = child.newSendAmount;
                        }else{
                            childObj.caseNum = child.newSendAmount;
                        }
                    }else{
                        if(child.sendSkuUnit == '箱'){
                            childObj.boxNum = child.sendAmount;
                        }else{
                            childObj.caseNum = child.sendAmount;
                        }
                    }
                    if(array.length > 0){
                        let skubox = array.filter(item => item.skuCode == child.skuCode);
                        let skuIndex = array.findIndex(item => item.skuCode == child.skuCode);
                        if(skubox.length != 0){
                            if(array[skuIndex].boxNum){
                                array[skuIndex].caseNum = that.isSearchShow ? child.newSendAmount : child.sendAmount;
                            }else{
                                array[skuIndex].boxNum = that.isSearchShow ? child.newSendAmount : child.sendAmount;
                            }
                        }else{
                            array.push(childObj);
                        }
                    }else{
                        array.push(childObj);
                    }
                })
                console.log(array);
                obj.skuAmounts = array;
                orders.push(obj);
            })
            let orderNos = [];
            if (!this.clickOrderNo) {
                orderNos = this.Orderselected.map(item => {
                    return item.orderNo;
                });
            } else {
                orderNos.push(this.clickOrderNo);
            }

            const params = {
                orderNos,
                orders,
                bodyId: this.deliverParam.bodyId,
            }
            const res = await OrderApi.batchReview(params)
            if(res.succ === 1) {
                this.$notifySuccess('审核成功');
            } else {
                this.$notifyError(res.error);
            }
            this.examParam.wsId = '';
            this.examParam.locId = '';
            this.popupActive2Shqr = false;
            this.clickOrderNo = '';
            this.Orderselected = [];
            this.getOrderformList();
        },
    },
    watch: {
        sendData: {
            handler() {
              this.validDeliver = this.sendData.every(item => item.frtId)
            },
            deep: true
        },
        "deliverParam.bodyId"(){
            this.deliverParam.wsId = '';
            this.distOptions = [];
        },
        "deliverParam.wsId"(){
            this.deliverParam.locId = '';
            this.locOptions = [];
        }
    }

};
</script>




<style lang="scss" scoped>
@import '../order/order.scss';
@import '@/modules/commodity-sys/commodity.scss';
.good-info>span{
    position: relative;
}
.good-info{
    position: relative;
    .order-now-show{
        display: none;
    }
    .order-now-sec{
        min-width: 1100px;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #333;
        justify-content: space-around;
        li{
            flex:1;
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-right: 1px solid #ebe9f1;
            color: #626262;
            z-index: 60000 !important;
            span{
                text-align: center;
            }
            span:nth-child(2){
                border-top: 1px solid #ebe9f1;
            }
        }
    }
}
.good-info:hover{
    position: relative;
}
.good-info:hover .order-now-show{
    display: block;
    min-width: 1110px;
    background: #fff;
    position: absolute;
    left: -500px;
    top: 40px;
    z-index: 60000;
}
.good-info .sku-summary{
    z-index: 500;
}
.search-item-border {
    border-radius: 0 !important;
    padding-right: 15px;
    margin-right: 10px;
    border-right: 1px solid #000;
}
.search-item-right {
    padding-left: 10px;
    border-left: 1px solid #000;
    display: flex;
    position: absolute;
    right: 0;
}
.expectation {
    color: #ccc !important;
}
/deep/ .deliver-pop {
  position: relative;
  /deep/ .v-select {
      width: 350px;
  }
  button {
    width: 126px;
    height: 38px;
    font-size: 14px;
  }
}
/deep/ .vs-dialog .vs-table--content {
    height: 400px !important;
}
/deep/ .remark-text span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.deliver-dialog{
  min-width: 800px;
}
.colTitle {
  line-height: 37px;
}
.deliver-btn {
  width: 100%;
  button {
      width: 126px;
      height: 38px;
      font-size: 14px;
  }
}
.edit-remark-textarea {
    width: 100%;
}
.follow-detail {
    .timeline-wrapper {
        width: 80%;
        margin: 0 auto;
        padding-top: 10px;
        max-height: 400px;
        overflow-y: auto;
        .addressee {
            display: flex;
            width: 80%;
            min-height: 50px;
            padding: 0 1.5rem 1rem 1.5rem;
            position: relative;
            left: 20%;
            .addressee-line {
                position: absolute;
                top: 5px;
                left: 0;
                width: 1px;
                height: 100%;
                background: #ebe9f1;
            }
            .addressee-item-point {
                position: absolute;
                width: 20px;
                height: 20px;
                top: 0px;
                z-index: 1;
                left: -10px;
                text-align: center;
                border-radius: 50%;
                background-color: rgb(64, 144, 255);
                span {
                    text-align: center;
                    font-size: 12px;
                    line-height: 20px;
                    color: #fff;
                }
            }
            .addressee-item-content {
                font-size: 12px;
            }
        }
    }
}
.excrete-logo{
    display: inline-block;
    padding: 0;
    width: 20px;
    height: 20px;
    text-align: center;
    background: rgb(64,144,255);
    font-size: 13px;
    line-height: 20px;
    color: white;
    border-radius: 50%;
}
.el-table {
    border: 1px solid #EBEEF5;
    /deep/ .el-table__row {
        .cell {
            white-space: pre-wrap;
        }
    }
    &::before {
        border: none;
        height: 0;
    }
}
.buyerName {
    color: #222;
}
.buyerType {
    font-size: 12px;
    color: #aaa;
}
.price-right {
    /deep/.vs-table-text {
        display: block;
        text-align: right;
    }
}
/deep/.vs-table--thead th {
    background: #fff;
}
.fixed-table-column {
    background: #fff !important;
}
.orderbox /deep/.vs-tabs--li {
    margin-right: 10px !important;
}

</style>

<style lang="scss">
.vs-dialog-text{
    height: calc(100% - 40px);
    overflow-y: auto;
}
.confim-popup .vs-dialog-text{
    height: calc(100% - 110px);
    overflow-y: auto;
}
.table-sec-box{
    padding-top: 20px;
    height: calc(100% - 40px);
    overflow-y: auto;
}
.flex-align{
    align-items: center;
}
.group-body{
    text-align: center;
    max-height: 410px;
    overflow-y: scroll;
}
.table-sec-box [dir] .el-input__inner{
    text-align: center;
    padding: 0;
}
.table-sec-box .el-input__inner{
    text-align: center;
    padding: 0;
}
.el-num-height{
    height: 40px;
    line-height: 40px;
    text-align: center;
}
.el-radio{
    display:block;
    text-align: left;
    margin-bottom: 10px;
}
.el-table__row:hover>td{
    background-color: #ecf5ff;
}
.el-table th>.cell{
    font-weight: bold;
    color: #333;
}
.el-table .cell{
    font-size: 12px;
}
.verify {
    .vs-dialog {
        height: 90vh;
        max-width:  1100px;
        .vs-dialog-text {
            // min-height: 500px;
        }
        .el-table__row {
            font-size: 12px;
        }
        .el-table td {
            padding: 2px 0 !important;
        }
    }
}
.el-select-dropdown {
    min-width: none !important;
    width: 200px !important;
}
.el-table .amount-red{
  color: #F56C6C;
}
.box-card{
    max-height: 500px;
    overflow: scroll;
    margin-top: -30px;
}

</style>
